import { Component, OnInit, ChangeDetectorRef, AfterViewInit, ViewChild, ElementRef, QueryList, ViewChildren } from "@angular/core";
import { FormArray, FormControl, FormGroup, Validators, FormBuilder } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import Swal from "sweetalert2";
import { NgbModal, NgbModalOptions, NgbTypeaheadConfig } from '@ng-bootstrap/ng-bootstrap';
import { Observable, OperatorFunction, catchError, debounceTime, distinctUntilChanged, finalize, forkJoin, map, of, pairwise, startWith } from "rxjs";
import { AddressBookService } from "src/app/services/general/addressbook.service";
import { NetworkService } from "src/app/services/network.service";
import { ProductService } from "src/app/services/products.service";
import { VendorService } from "src/app/services/vendor.service";
import { ManifestService } from "src/app/services/operations/manifest.service";
import { GeoService } from "src/app/services/geo.service";
import { ColumnApi, GridApi, GridOptions, GridReadyEvent } from "ag-grid-community";
import { NgxUiLoaderService } from "ngx-ui-loader";
import { AppCoreService } from "src/app/services/app-core.service";
import { AWBDeleteActionsRenderer } from "src/app/components/shared/ag-grid/cell-renderers/awb-delete.component";
import { AmountValidation, EmailValidation, MobileNumberValidation, nonZeroValidator, TelephoneNumberValidation } from "src/app/models/validator";
import { CustomerService } from "src/app/services/customer.service";
import { AWBService } from "src/app/services/operations/awb.service";
import { lastValueFrom } from 'rxjs';
import { CheckboxCellComponent } from "src/app/components/shared/ag-grid/cell-renderers/checkbox-cell.component";
import { MiscService } from "src/app/services/misc/misc.service";
import { ChildAWBGridComponent } from "../child-awbmodel/child-awb.component";
import { BagGrid, PiecesDetails } from "src/app/models/manifest";
import { FileHandlerService } from "src/app/services/file-handler.service";
import { CompanyService } from "src/app/services/company.service";
import { CreditControlService } from "src/app/services/system-config/credit-control/creditcontrol";
import { Utilities } from "src/app/models/utilities";
import { Title } from "@angular/platform-browser";
import { NgSelectComponent } from "@ng-select/ng-select";
import { AddressComponent } from "src/app/components/shared/address/address.component";
import { ConfigService } from "src/app/services/system-config/configs/configs.service";
import { UserManagementService } from "src/app/services/user-management.service";
import { ChargesService } from "src/app/services/system-config/charges/charges.service";
import { RateUploadService } from "src/app/services/operations/rateupload.service";

enum ChargeType {
  AWB = "Customer",
  PURCHASE = "Vendor"
}

enum RateCategory {
  CUSTOMER = "Customer",
  VENDOR = "Vendor"
}

enum MeasurementUnit {
  CENTIMETER = 5000,
  INCHES = 2000
}

@Component({
  selector: 'app-addmanifest',
  templateUrl: './addmanifest.component.html',
  styleUrls: ['./addmanifest.component.scss']
})
export class AddManifestComponent implements OnInit, AfterViewInit {
  @ViewChild('awbNoInput') awbNoInput!: ElementRef;
  @ViewChild('crnmhbsno') crnmhbsno!: ElementRef;
  @ViewChild('serviceCenterRef') serviceCenterRef!: NgSelectComponent;
  @ViewChild('vendorRef') vendorRef!: NgSelectComponent;
  @ViewChild('bagNoRef') bagNoRef!: NgSelectComponent;
  @ViewChild('submitBtn') submitBtn!: ElementRef;
  @ViewChild('countryRef') countryRef!: NgSelectComponent;
  @ViewChild('flight1Ref') flight1Ref!: ElementRef;
  bagGridObj: BagGrid;
  manifestId: number;
  manifestForm: FormGroup;
  generateForm: FormGroup;
  isGenerateFormSubmitted = false;
  awbDetailsForm: FormGroup;
  flightForm: FormGroup;
  gridForm: FormGroup;
  permConfig = {
    isViewAllowed: false,
    isAddAllowed: false,
    isEditAllowed: false,
    isDeleteAllowed: false
  };

  // address
  isFormSubmitted = false;
  shipperLocationInfo: any = {};
  consigneeLocationInfo: any = {};
  countryList = []
  conditionalCountryList = [];
  isShipperCustomerBinded = false;
  focusCheckHide = true;
  productFilteredCountryList = [];
  originCountryList = [];
  originStateList = [];
  originCityList = [];
  destinationCountryList = [];
  destinationStateList = [];
  destinationCityList = [];
  customerData: any;

  awbFocusCheckMap: any = [];
  awbAddressFocusCheckMap: any = [];
  focusConsigneeName: boolean = false;

  getOriginLocation(location: any) {
    this.originCountryList = location?.[0]?.country || [];
    this.originStateList = location?.[0]?.state || [];
    this.originCityList = location?.[0]?.city || [];
    // this.documentTypeValidation('shipperdoc');
    // this.getAWBCharges(RateCategory.CUSTOMER);
  }

  getDestinationLocation(location: any) {
    this.destinationCountryList = location?.[0]?.country || [];
    this.destinationStateList = location?.[0]?.state || [];
    this.destinationCityList = location?.[0]?.city || [];
    // this.documentTypeValidation('consigneedoc');
    // this.getAWBCharges(RateCategory.CUSTOMER);
  }

  getAddressbookList(event: any) {
    this.addressBookList = event;
  }
  @ViewChild('customer') customer!: NgSelectComponent;
  @ViewChild('appShipperAddress') appShipperAddress!: AddressComponent;
  @ViewChild('appConsigneeAddress') appConsigneeAddress!: AddressComponent;
  @ViewChildren('piecesActualWeight') piecesActualWeightInputs!: QueryList<ElementRef>;
  @ViewChildren('weightRef') weightRef: QueryList<ElementRef>;
  @ViewChildren('descriptionRef') descriptionRefs: QueryList<ElementRef>;
  @ViewChildren(
    'referenceNo, awbNo, customer, company, bookDateTime, paymentType, product, vendor, service, ' +
    'ChargeTypes, shipmentValue, currency, appShipperAddress, shipperiecioeno, appConsigneeAddress, consigneeiecioeno, piecesActualWeightInputs'
  ) fields!: QueryList<any>;
  @ViewChild('pieceAddBtn') pieceAddBtn!: ElementRef;

  changeFocusOnSwitch() {
    const createAwbOn = this.manifestForm.get('chkCreateAwb').value;
    if (createAwbOn) {
      this.showAWBDetailsForm = true;
      setTimeout(() => {
        this.customer.focus();
      }, 100);
    } else {
      this.showAWBDetailsForm = false;
    }
  };

  focusNextField(currentField?: string) {
    // If no currentField is provided, find the smallest `no` field with `value: true`
    let nextField;

    if (!currentField) {
      nextField = this.awbFocusCheckMap?.reduce((min, item) =>
        item.value && (!min || item.no < min.no) ? item : min, null);
    } else {
      // Find the current field based on `no`
      const currentItem = this.awbFocusCheckMap?.find(item => item.key === currentField);
      if (!currentItem) return; // If not found, exit

      const currentNo = currentItem.no;

      // Find the next field with the smallest `no` that has `value: true`
      nextField = this.awbFocusCheckMap?.find(item => item.no > currentNo && item.value);
    }

    if (nextField) {
      if (nextField.key === 'appShipperAddress') {
        this.appShipperAddress.focusFirstField();
        return;
      } else if (nextField.key === 'appConsigneeAddress') {
        this.appConsigneeAddress.focusFirstField();
        return;
      } else if (nextField.key === 'piecesActualWeightInputs') {
        this.focusFirstActualWeight();
        return;
      }

      setTimeout(() => {
        const field = this.fields.find(el =>
          (el instanceof NgSelectComponent && el.element.id === nextField.key) ||
          (el instanceof ElementRef && el.nativeElement.id === nextField.key)
        );

        if (field instanceof NgSelectComponent) {
          if (!field.disabled) {
            field.focus();
          } else {
            this.focusNextField(nextField.key); // Skip disabled field
          }
        } else if (field instanceof ElementRef) {
          if (!field.nativeElement.disabled) {
            field.nativeElement.focus();
          } else {
            this.focusNextField(nextField.key); // Skip disabled field
          }
        } else {
          this.focusNextField(nextField.key); // Continue to the next field if not found
        }
      });
    }
  }

  focusFirstActualWeight() {
    setTimeout(() => {
      const firstInput = this.piecesActualWeightInputs.first;
      if (firstInput) {
        firstInput.nativeElement.focus();
      }
    }, 0);
  }

  updateAddressCheck(e: any) {
    this.awbAddressFocusCheckMap = e;
  }

  focusSubmitBtn() {
    setTimeout(() => {
      this.submitBtn.nativeElement.focus();
    }, 200);
  }

  focusNextContainer(index: number) {
    const nextContainer = document.querySelectorAll('input[formControlName="piecesactualweight"]')[index];
    if (nextContainer) {
      (nextContainer as HTMLElement).focus();
    }
  }

  focusItemWeightRef() {
    setTimeout(() => {
      if (this.weightRef instanceof QueryList && this.weightRef.first) {
        this.weightRef.first.nativeElement.focus();
      }
    }, 100);
  };

  onKeyDownblockKeyForShipment(event: KeyboardEvent) {
    if (event.keyCode == 69 || event.keyCode == 107) {
      event.preventDefault();
    }
  }

  focusConsignee() {
    const shipperControl = this.awbDetailsForm.get('shipperlocationdetails.txtName');
    // Emit an event to the child component
    if (shipperControl?.valid && shipperControl.value !== 'string') {
      this.focusConsigneeName = true;
    }
  }

  //
  manifestFormSubmitted: boolean;
  awbDetailsFormSubmitted: boolean;
  showAWBDetailsForm: boolean;
  awbNoList: any[];
  childAWBNoList: any[];
  filteredAwbList: any[];
  forwardingAwbList: any[];
  loadVendorsList: any[] = [];
  reservedAWBList: any[] = [];

  showVendors = false;
  serviceCenterList: any[] = [];
  vendorList: any[] = [];
  customerList: any[] = [];
  PaymentModeList: [] = [];
  productList: any[] = [];
  resProductOptions: any[] = [];
  resCustomerList: any[] = [];
  vendorServiceList: any[] = [];
  addressBookList: any[] = [];
  unitList: any[] = ['Centimeter', 'Inches'];
  consigneeaddressbookid: number;

  awbNumber: string = '';
  forwardingAwbNo: string = '';
  piecesMandate: boolean;
  piecesfldDet: any;
  numberOfRowsToGenerate: number;
  finalList: any[] = [];
  piecesDetailsList: any[] = [];
  newRow: PiecesDetails = {
    piecelength: null,
    piecebreadth: null,
    pieceheight: null,
    actualweight: null,
    volumetricweight: null,
    chargeableweight: null
  }
  awbNoArray: any[] = [];
  masterAwbNo: number;
  selectedVendorid: number;
  selectedServiceid: number;
  isActionAllowed = true;
  manifestedAWbs: any[] = []
  public isCollapsed = true;
  private gridApi!: GridApi;
  private gridColumnApi!: ColumnApi;
  public context: any;
  checkManifetForAndFocus() {
    const selectedManifetFor = this.manifestForm.get('manifestFor').value;
    setTimeout(() => {
      selectedManifetFor === 'Service Center' ? this.serviceCenterRef.focus() : this.vendorRef.focus();
    }, 100);
  }
  defaultColDef = {
    filter: true,
    sortable: true,
    resizable: true,
  };
  viewOnlyPage = false;
  gridOptionsBagWise: GridOptions = {
    pagination: true,
    paginationPageSize: 10,
    domLayout: 'autoHeight',
  }

  gridOptionsBagDetail: GridOptions = {
    pagination: true,
    paginationPageSize: 10,
    domLayout: 'autoHeight',
  };

  GridOptionsAWBWise: GridOptions = {
    pagination: true,
    paginationPageSize: 10,
    domLayout: 'autoHeight',
  }

  totals = { totalAmount: 0, totalWeight: 0, totalQuantity: 0 };
  rowDataAwbWise = [];
  rowDataBagWise = [];
  rowDataLatestBagDetail = [];
  columnDefsBagWise = [
    { headerName: 'Show', field: '', cellRenderer: CheckboxCellComponent, filter: false, minWidth: 58 },
    { headerName: 'Bag no.', field: 'bagno', cellStyle: { textAlign: 'center' } },
    { headerName: `AWB Count`, field: 'awbcount', cellStyle: { textAlign: 'center' }, minWidth: 150 },
    { headerName: 'Weight', field: 'weight', cellStyle: { textAlign: 'end' } },
    {
      headerName: 'Actions',
      field: 'id',
      cellRenderer: AWBDeleteActionsRenderer,
      cellClass: "actions-button-cell",
      cellStyle: { "overflow": 'visible', textAlign: 'start' },
      colId: 'params',
      editable: false,
      sortable: false,
      filter: false,
      minWidth: 80
    },
  ];
  manifestFor = 'Service Center';
  colDefsLatestBagDetail = [
    { headerName: 'AWB No.', field: 'awbnumber', width: 170 },
    { headerName: 'Weight', field: 'actualweight', width: 120 },
  ];

  masterNo: any;
  columnDefsAwbWise = [
    { headerName: 'Awb no.', field: 'awbnumber' },
    // { headerName: 'Bag no.', field: 'bagnumber', cellStyle: { textAlign: 'center' } },
    {
      headerName: 'Booking Date',
      field: 'bookingdate',
      cellRenderer: (params: { value: any }) => {
        const { dateString } = this.utilities.FormatDateWithTime(0, params.value);
        const [year, month, day] = dateString.split('-');
        return `${day}-${month}-${year}`;
      },
    },
    { headerName: 'Consignee', field: 'consigneename' },
    { headerName: 'CRN MHBS No.', field: 'crnnumber' },
    { headerName: 'Actual Weight', field: 'actualweight', cellStyle: { textAlign: 'center' }, width: 140 },
    { headerName: 'Volumetric Weight', field: 'volumetricweight', cellStyle: { textAlign: 'center' }, width: 150 },
    {
      headerName: 'Actions',
      field: 'id',
      cellRenderer: AWBDeleteActionsRenderer,
      cellClass: "actions-button-cell",
      cellStyle: { "overflow": 'visible' },
      colId: 'params',
      editable: false,
      sortable: false,
      width: 100,
      pinned: 'right',
    }
  ];

  showAwbWise = true;
  showBagWise = false;
  flightList: any[] = [];
  allBagList: any[] = [];

  selectedAWBList: any[] = [];
  selectedSCId: number;
  bagsList: any[] = [];
  reservebagsList: any[] = [];
  selectedBagsList: any = [];
  crnnumber: string;
  awbConfig = {
    isPaymentModeDisable: false,
    isAllowedZeroAmountEntry: false,
    isShippingApiBasedOnCustomerAwb: false,
    isVolumetricRequired: false
  }

  serviceConfig = {
    proforma: {
      detailsmandatory: false,
      documentrequired: false
    }
  }
  piecesForm: FormGroup;
  useEnterKey = false;
  private isDialogOpen = false; // Flag to track dialog state
  matchedShipper = null;
  matchedConsignee = null;

  shipmentDetails = {
    previousAmount: 0,
    shipperAddressBookId: null,
    consigneeAddressBookId: null,
    customerId: 0,
    isAwbBind: false,
    totalPiecesDisable: true,
    tempPiecesId: 0,
    isTypeAndId: false
  };
  isDOXSelected = false;
  customerConfig: any = {};
  vendorConfig: any = {};
  totalCustomerCharges: number = 0;
  customerRowData = [];
  chargeList = [];
  totalShipment: number;

  constructor(
    private _fb: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private addressbookService: AddressBookService,
    private networkService: NetworkService,
    private customerService: CustomerService,
    private productService: ProductService,
    private vendorService: VendorService,
    private manifestService: ManifestService,
    private awbService: AWBService,
    private typeaheadConfig: NgbTypeaheadConfig,
    private readonly changeDetectorRef: ChangeDetectorRef,
    private geoService: GeoService,
    private ngxLoaderService: NgxUiLoaderService,
    private appCoreService: AppCoreService,
    private miscService: MiscService,
    public modalService: NgbModal,
    private companyService: CompanyService,
    private fileHandlerService: FileHandlerService,
    private creditControlService: CreditControlService,
    private utilities: Utilities,
    private titleService: Title,
    private configService: ConfigService,
    private userManagementService: UserManagementService,
    private chargesService: ChargesService,
    private rateUploadService: RateUploadService,
  ) {
    titleService.setTitle('Manifest');
    typeaheadConfig.selectOnExact = true;

    this.context =
    {
      componentParent: this,
      componentName: 'AddManifestComponent',
      actionConfig: { hideDelete: false }
    };

  }
  piecesLength: number = 1;
  expandedRows: boolean[] = [];
  unitOptions: any[] = [{ name: 'KGS' }, { name: 'LBS' }, { name: 'CBM' }];

  containerItemUnitOptions: any[] = [{ code: "BOX", name: "Boxes" }, { code: "BOTTLE", name: "Bottle" }, { code: "KGS", name: "Kilogram" }, { code: "PCS", name: "Pieces" }, { code: "PKT", name: "Packet" }, { code: "SET", name: "Set" }];
  paymentTypeList = ['Cash', 'Credit', 'COD'];
  bookingDate: any;
  companyList: any[] = [];
  respCompanyList: any[] = [];
  selectChargeTypes: string[];
  isAccessTypeCustomer = false;
  minDateTime: string | number | Date;
  currentDateTime: any;
  isCreditControlChecked = false;
  volumetricList: any[] = [];
  selectedProduct: any = null;

  ngOnInit() {
    this.minDateTime = this.utilities.FormatDateWithTime(-1).dateTimeString;
    this.currentDateTime = this.utilities.FormatDateWithTime();
    this.selectChargeTypes = ["Commercial", "Medical", "ODA"];
    this.manifestId = this.route.snapshot.params['id'];
    const defaultOnEdit = this.manifestId ? true : false;
    this.manifestForm = this._fb.group({
      // ddlBranch: new FormControl({ value: null, disabled: defaultOnEdit }, Validators.required),
      txtDateTime: [{ value: this.currentDateTime?.dateString, disabled: defaultOnEdit }, [Validators.required, this.utilities.minDateValidator()]],
      manifestFor: new FormControl({ value: 'Service Center', disabled: defaultOnEdit }),
      ddlLoadVendor: new FormControl({ value: null, disabled: defaultOnEdit }),
      txtRemarks: new FormControl({ value: null, disabled: defaultOnEdit }),
      ddlCompany: new FormControl({ value: null, disabled: defaultOnEdit }),
      ddlServiceCenter: new FormControl({ value: null, disabled: defaultOnEdit }),
      ddlVendor: new FormControl({ value: null, disabled: defaultOnEdit }),
      chkCreateAwb: [false],

      filterDeastinationForm: this._fb.group({
        ddlDestinationCountry: [null],
        ddlDestinationState: [null],
        ddlDestinationCity: [null],
      })
    });

    this.generateForm = this._fb.group({
      chkAwbWise: ['awbwise'],
      txtAwbOrForwardingNo: [null, Validators.required],
      txtCRNNo: [null],
      ddlBagNo: [null, Validators.pattern(/^(?:[1-9]|[1-9]\d{1,2}|999)$/)],
      awbList: [null],
      bagList: [null],
    });

    this.flightForm = this._fb.group({
      txtFlight1: [null],
      txtFlight1ArrivalDate: [this.currentDateTime.dateTimeString],
      txtFlight2: [null],
      txtFlight2ArrivalDate: [this.currentDateTime.dateTimeString],
      txtAirlinePrefix: [null],
      txtAwbSeries1: [null],
      txtAwbSeries2: [null],
      txtCDNo: [null],
      txtEDIMasterNo: [{ value: null, disabled: true }],
    })

    this.awbDetailsForm = this._fb.group({
      txtBookingDate: [this.currentDateTime.dateTimeString, [Validators.required, this.utilities.minDateValidator()]],
      ddlCustomer: [null],
      ddlCompanies: [null, Validators.required],
      ddlProduct: [null, Validators.required],
      ddlVendor: [null, Validators.required],
      ddlVendorService: [null, Validators.required],
      ddlChargeType: [],
      txtPieces: [],
      ddlPiecesUnit: [this.unitList[0]],
      txtTotalActualWeight: [null],
      txtTotalVolumetricWeight: [],
      txtTotalChargeableWeight: [{ disabled: true, value: null }],
      ddlPaymentType: [this.paymentTypeList[0], Validators.required],
      txtShipmentValue: [null],
      txtShipperName: [null],
      txtShipperPerson: [null],
      txtShipperEmail: [null],
      txtConsigneeName: [null],
      txtConsigneePerson: [null],
      txtConsigneeEmail: [null],
      txtFile: [null],
      txtTotalPiecesFileId: [],
      ddlMeasurementUnit: [this.unitList[0]],
      txtDivision: [{ disabled: true, value: '5000' }],

      shipperlocationdetails: this._fb.group({
        ddlCountry: [null, Validators.compose([Validators.required])],
        txtName: [null, Validators.compose([Validators.required])],
        txtContactPerson: [null],
        txtEmail: [null, Validators.compose([EmailValidation, , Validators.maxLength(150)])],
        txtPincode: [null],
        ddlState: [null],
        ddlCity: [null],
        txtAddress1: [null, Validators.compose([Validators.required, Validators.maxLength(150)])],
        txtAddress2: [null, Validators.maxLength(150)],
        txtArea: [null, Validators.maxLength(30)],
        txtMobileNo: [null, Validators.compose([Validators.required, MobileNumberValidation])],
        txtTelephoneNo: [null, TelephoneNumberValidation],
      }),

      consigneelocationdetails: this._fb.group({
        ddlCountry: [null, Validators.compose([Validators.required])],
        txtName: [null, Validators.compose([Validators.required])],
        txtContactPerson: [null],
        txtEmail: [null, Validators.compose([EmailValidation, , Validators.maxLength(150)])],
        txtPincode: [null],
        ddlState: [null],
        ddlCity: [null],
        txtAddress1: [null, Validators.compose([Validators.required, Validators.maxLength(150)])],
        txtAddress2: [null, Validators.maxLength(150)],
        txtArea: [null, Validators.maxLength(30)],
        txtMobileNo: [null, Validators.compose([Validators.required, MobileNumberValidation])],
        txtTelephoneNo: [null, TelephoneNumberValidation],
      }),
    });

    this.piecesForm = this._fb.group({
      totalpieces: [{ value: 0, disabled: true }],
      totalactualweight: [{ value: '0.000', disabled: true }, Validators.compose([Validators.required, Validators.pattern(/^\d{0,9}(\.\d{0,3})?$/)])],
      totalvolumetricweight: [{ value: '0.000', disabled: true }, Validators.compose([Validators.required, Validators.pattern(/^\d{0,9}(\.\d{0,3})?$/)])],
      totalchargeableweight: [{ value: '0.000', disabled: true }, Validators.compose([Validators.required, Validators.pattern(/^\d{0,9}(\.\d{0,3})?$/)])],
      actualweightunit: ['KGS'],
      measurementunit: [''],
      containers: this._fb.array([])
    });
    this.gridForm = this._fb.group({
      summaryTypeSwitch: ['awbwise']
    })
    this.piecesDetailsList.push(this.newRow);
    this.manifestFormSubmitted = false;
    this.checkPermission();

    if (this.permConfig.isAddAllowed) {
      this.loadDataFromAPI();
      this.getAllFlights();
      this.bindDefaultPiecesContainer();
      // this.bindItemDescriptions();
      this.updateServiceCenterVendorValidator()
      // this.getAwbDetailsById();
      this.awbDetailsForm.get('ddlCustomer')?.valueChanges.pipe(startWith(this.awbDetailsForm.get('ddlCustomer')?.value), pairwise()).subscribe(([previousValue, currentValue]) =>
        previousValue != currentValue && this.checkVolumetricDetail());

      this.awbDetailsForm.get('ddlProduct')?.valueChanges.pipe(startWith(this.awbDetailsForm.get('ddlProduct')?.value), pairwise()).subscribe(([previousValue, currentValue]) =>
        (currentValue && previousValue != currentValue) ? this.onProductChange(currentValue) : this.selectedProduct = null);

      this.awbDetailsForm.get('ddlVendor')?.valueChanges.pipe(startWith(this.awbDetailsForm.get('ddlVendor')?.value), pairwise()).subscribe(([previousValue, currentValue]) =>
        previousValue != currentValue && this.checkVolumetricDetail());

      this.awbDetailsForm.get('ddlService')?.valueChanges.subscribe((value) => value && this.checkVolumetricDetail());

      this.awbDetailsForm.get('ddlCompanies').valueChanges.pipe(startWith(this.awbDetailsForm.get('ddlCompanies')?.value), pairwise()).subscribe(([previousValue, currentValue]) =>
        currentValue && previousValue != currentValue && this.onChangeCompany(currentValue));

      this.piecesForm.valueChanges.subscribe(() => { this.calculateTotals() });

      this.appCoreService.SelectedServiceCenter().subscribe(async (val) => {
        this.selectedSCId = val;
        this.getServiceCenters();
        // console.log('this.selectedSCId', this.selectedSCId);
        await this.getAllBags();
      });
    }
    // this.resetawbDetailsForm()
  }

  loadDataFromAPI() {
    this.ngxLoaderService.start();
    try {
      forkJoin({
        countries: this.geoService.GetAllCountries(),
        customers: this.customerService.GetAll({ isactive: true, scid: this.appCoreService.GetUserData().selectedServiceCenter }),
        companies: this.companyService.GetAll({ isactive: true }),
        products: this.productService.GetAll({ isactive: true }),
        vendors: this.vendorService.GetAll({ isactive: true }),
        itemDescription: this.miscService.GetAllGoods(),
        users: this.userManagementService.GetUserByGroup('fe,se', this.selectedSCId),
        awbConfig: this.configService.getAllGlobalConfig(),
        paymentModes: this.miscService.GetAllPaymentModes(),
        moduleConfigByClientId: this.configService.getModuleConfigByClientId(),
      }).pipe(
        finalize(async () => {
          await this.getAllVendorServices();
          this.bindShipperLocationOverSc();

          // set default company
          let defaultCompanyId = this.companyList.find(x => x.isdefault)?.id;
          this.awbDetailsForm.get('ddlCompanies').setValue(defaultCompanyId);

          // Filter customers whose companyids array contains at least one matching company ID
          if (defaultCompanyId)
            this.customerList = this.resCustomerList.filter(cust => cust.companyids.some(id => id == defaultCompanyId));
          else
            this.customerList = this.resCustomerList;

          const ud: any = this.appCoreService.GetUserData();
          if (ud && ud.accessType == "Customer") {
            this.isAccessTypeCustomer = true;
            this.awbDetailsForm.get('ddlCustomer').setValue(this.customerList.find(x => x.id == ud?.metaInfo?.customerid)?.id);
            this.awbDetailsForm.get('txtReferenceNo').disable();
            this.awbDetailsForm.get('txtAwbNo').disable();
            this.awbDetailsForm.get('ddlCustomer').disable();
            this.awbDetailsForm.get('txtDateTime').disable();
          }
          this.ngxLoaderService.stop();
        })
      ).subscribe((res) => {
        if (res) {
          if (res.countries.success && res?.countries?.data) {
            this.countryList = res?.countries?.data || [];
            this.productFilteredCountryList = this.countryList || [];
          }
          if (res.customers.success && res.customers?.data) {
            this.resCustomerList = res.customers?.data;
          }
          if (res.companies.success && res.companies?.data) {
            this.respCompanyList = res.companies?.data;
            //list those customers only who have selected service center as their active one.
            this.companyList = this.respCompanyList.filter(cust => cust?.servicecenters && cust?.servicecenters?.some(scid => scid == this.selectedSCId));
          }
          if (res.products.success && res.products?.data) {
            this.productList = res.products?.data;
            this.resProductOptions = res.products?.data;
          }
          if (res.vendors.success && res.vendors?.data) {
            this.vendorList = res.vendors?.data;
          }
          if (res.itemDescription.success && res.itemDescription?.data) {
            this.itemDescriptionList = res.itemDescription?.data;
          }

          if (res.awbConfig.success && res.awbConfig?.data) {
            this.checkAwbConfig(res?.awbConfig.data.filter(x => x.categoryname == 'AWB'));
          }

          if (res.moduleConfigByClientId.success && res.moduleConfigByClientId?.data) {
            const creditControl = res.moduleConfigByClientId?.data?.[0]?.planconfig?.moduleconfig?.find(res => res.name === 'Credit Control');
            this.isCreditControlChecked = creditControl?.checked;
          }
        }
      })
    } catch (error) {
      this.ngxLoaderService.stop();
    }
  };

  calculateTotals() {
    this.totals.totalAmount = 0;
    this.totals.totalWeight = 0;
    this.totals.totalQuantity = 0;

    this.containers.controls.forEach((container: FormGroup) => {
      const subitems = container.get('containeritemsgroup.subitems')?.value || [];
      subitems.forEach((item: any) => {
        this.totals.totalAmount += Number(item.itemamount) || 0;
        this.totals.totalWeight += Number(item.itemweight) || 0;
        this.totals.totalQuantity += Number(item.itemquantity) || 0;
      });
    });

    this.totals.totalAmount = parseFloat(this.totals.totalAmount.toFixed(2));
    this.totals.totalWeight = parseFloat(this.totals.totalWeight.toFixed(3));
  }

  onChangeCompany(value) {
    if (value) {
      // Filter customers whose companyids array contains at least one matching company ID
      this.customerList = this.resCustomerList.filter(cust => cust.companyids.some(id => id == value));

      // filter products based on company operation type
      this.awbDetailsForm.get('ddlProduct').reset();
      const companyOperationTypeArray = this.companyList.find(x => x.id === value)?.operationtype;
      this.productList = this.resProductOptions.filter(option => companyOperationTypeArray?.includes(option.producttype));
    }
  }

  checkVolumetricDetail() {
    const customer = this.awbDetailsForm.get('ddlCustomer')?.value;
    const product = this.awbDetailsForm.get('ddlProduct')?.value;
    const vendor = this.awbDetailsForm.get('ddlVendor')?.value;
    const service = this.awbDetailsForm.get('ddlService')?.value;
    const serviceObject = Array.isArray(service) ? service[0] : service;
    if (customer && product && vendor && serviceObject) {
      const requestObj = {
        customerid: customer,
        productid: product,
        vendorid: vendor,
        serviceid: service
      };

      this.customerService.getVolumetricDataForAwb(requestObj).subscribe((res) => {
        if (res?.success) {
          this.volumetricList = res.data;
          if (this.volumetricList.length > 0) {
            if (this.awbDetailsForm.get('ddlMeasurementUnit')?.value === 'Inches') {
              this.awbDetailsForm.get('txtDivision').setValue(this.volumetricList[0].inches);
            } else {
              this.awbDetailsForm.get('txtDivision').setValue(this.volumetricList[0].centimeter);
            }
          } else {
            this.awbDetailsForm.get('txtDivision')?.setValue(
              this.awbDetailsForm.get('ddlMeasurementUnit')?.value === 'Inches' ? MeasurementUnit.INCHES : MeasurementUnit.CENTIMETER
            );
          }

        } else if (res && !res.success && res?.data?.err_msg) {

          this.appCoreService.showMessage(res.data.err_msg, "Error", 'error')
        }
      })

    } else {
      return;
    }
  }

  getAwbConfigs() {
    this.configService.getAllGlobalConfig().subscribe((res) => {
      if (res && res.success) {
        this.checkAwbConfig(res?.data.filter(x => x.categoryname == 'AWB'));
      }
    })
  };

  checkAwbConfig(awbconfig: any) {
    // console.log("awbconfig", awbconfig);
    for (let config in awbconfig) {
      switch (awbconfig[config].configurationcode) {
        case 'DISABLE_PAYMENT_MODE':
          this.awbConfig.isPaymentModeDisable = awbconfig[config].active;
          // this.awbConfig.isPaymentModeDisable ? this.receiptForm.get('ddlPaymentMode')?.disable() : this.receiptForm.get('ddlPaymentMode')?.enable();
          break;
        case 'CUSTOMER_LOGIN_VOLUMETRIC_REQUIRED_ON_NDOX':
          this.awbConfig.isVolumetricRequired = awbconfig[config].active;
          break;
        default:
          break;
      }
    }
  }

  bindShipperLocationOverSc() {
    this.networkService.GetServiceCentersById(this.selectedSCId).subscribe((res) => {
      if (res && res.success) {
        let location = res?.data[0]?.location;
        if (location) {
          this.shipperLocationInfo = {
            ...this.shipperLocationInfo,
            location: {
              country: location.country,
              state: location.state,
              city: location.city
            }
          }
        }
      }
    })
  }

  handleAwbFieldFocus() {
    const awbControl = this.generateForm.get('txtAwbOrForwardingNo');
    if (awbControl.valid && awbControl?.value != '') {
      this.crnmhbsno.nativeElement.focus();
    } else {
      awbControl?.markAsTouched();
    }
  }

  ngAfterViewInit() {
    this.useEnterKey ? this.utilities.focusFirstElement(this.manifestForm) : null;

    this.manifestId ? this.getManifestById() : null;
    !this.viewOnlyPage ? this.getAllAvailableAwb() : null;
    !this.manifestId ? this.getEDINo() : null;
  }

  getEDINo() {
    try {
      this.ngxLoaderService.start();
      this.manifestService.GetEDINo(this.selectedSCId).subscribe(res => {
        if (res?.success) {
          this.ngxLoaderService.stop();
          const ediDetails = res.data.ediconfig || null;

          let masterEDINo: string = res.data.lastmasteredino || "";
          if (masterEDINo) {
            const prefix = masterEDINo.substring(0, 2); // Extract the prefix
            const startFrom = parseInt(masterEDINo.substring(2), 10) + 1; // Extract and increment the numeric part
            const newMasterEDINo = prefix + startFrom.toString().padStart(5, '0');
            if (newMasterEDINo) return this.flightForm.get('txtEDIMasterNo').setValue(newMasterEDINo);
          }

          masterEDINo = ediDetails ? (ediDetails?.edinoprefix + ediDetails?.edinostartfrom + 1) : null;
          if (masterEDINo && masterEDINo != '' || masterEDINo != undefined) this.flightForm.get('txtEDIMasterNo').setValue(masterEDINo);
        }
      })
    } catch (error) {
      this.ngxLoaderService.stop();
    }
  }

  checkPermission(): any {
    const userData = this.appCoreService.GetUserData();
    this.useEnterKey = !userData.metaInfo.tabbasedtemplate;
    const permission = userData.config.filter(x => x.categoryname === 'Manifests');
    if (permission.length) {
      this.permConfig.isViewAllowed = permission[0].view;
      this.permConfig.isAddAllowed = permission[0].add;
      this.permConfig.isEditAllowed = permission[0].edit;
      this.permConfig.isDeleteAllowed = permission[0].delete;
    }
  }

  bindCompanies() {
    try {
      this.companyService.GetAll({ isactive: true }).subscribe((res) => {
        if (res && res.success) {

          this.companyList = res.data;
          this.respCompanyList = res.data;
          //if any default company bind it to field : else this.companyList 
          let defaultCompany = this.companyList.filter(x => x.isdefault)[0]?.id || null;
          this.awbDetailsForm.get('ddlCompanies').setValue(defaultCompany);
        }
      });
    } catch (e) {
      console.error(e);
    }
  }

  // Check if the parent AWB has any remaining child AWBs
  async addItems(itemsType: string) {
    this.isGenerateFormSubmitted = true;
    let selectedAWB: any = this.generateForm.get('txtAwbOrForwardingNo')?.value;
    const selectedBagId = this.generateForm.get('ddlBagNo')?.value;
    // freeze manifest for
    if (!this.manifestForm.get('ddlServiceCenter')?.value && !this.manifestForm.get('ddlVendor')?.value) return this.openWarningDialog('Please select Manifest for - Service Center or Third Party.');

    if (itemsType === 'AWB' && selectedAWB && selectedAWB != '') {
      if (!selectedAWB || typeof selectedAWB === 'string') {
        selectedAWB = this.awbNoList.find(x => x.awbnumber === selectedAWB?.trim());
        if (!selectedAWB) {
          this.generateForm.get('txtAwbOrForwardingNo').reset();
          this.awbNoInput.nativeElement.focus();
          // this.isGenerateFormSubmitted = false;
          return this.appCoreService.showMessage('Please type AWB Number and Select from List to add in manifest', 'AWB Number not found.', 'error');
        }
      }
      let isSelectedParentAWB = selectedAWB.isparentawb;
      this.crnnumber = this.generateForm.get('txtCRNNo')?.value;

      selectedAWB.crnnumber = this.crnnumber;

      if (isSelectedParentAWB) {
        let childAwbList = this.awbNoList.filter(x =>
          x.parentawbnumber === selectedAWB.awbnumber &&
          (x.parentawbnumber != null || x.parentawbnumber != '') &&
          !this.selectedAWBList.some(selected => selected.awbnumber === x.awbnumber)
        );

        if (childAwbList.length) {
          await this.openAWBConfirmationDialog(childAwbList);
        } else {
          // Ensure selected AWB is not already in the selected list
          if (!this.selectedAWBList.some(item => item.awbnumber === selectedAWB.awbnumber)) {
            this.selectedAWBList = [...this.selectedAWBList, selectedAWB];
            // Remove the selected AWB from awbNoList
            this.awbNoList = this.awbNoList.filter(item => item.awbnumber !== selectedAWB.awbnumber);
            // Check and remove the parent AWB if no more children exist
            let parentAwbNumber = selectedAWB.parentawbnumber;
            if (parentAwbNumber) {
              let hasChildren = this.awbNoList.some(item => item.parentawbnumber === parentAwbNumber);
              if (!hasChildren) {
                this.awbNoList = this.awbNoList.filter(item => item.awbnumber !== parentAwbNumber);
              }
            }
          }
        }
      } else {
        selectedAWB.crnnumber = this.crnnumber;
        this.crnnumber = null;
        if (!this.selectedAWBList.some(item => item.awbnumber === selectedAWB.awbnumber)) {
          this.selectedAWBList = [...this.selectedAWBList, selectedAWB];
          // Remove the selected AWB from awbNoList
          this.awbNoList = this.awbNoList.filter(item => item.awbnumber !== selectedAWB.awbnumber);
        }
      }
      this.generateForm.get('txtAwbOrForwardingNo').reset();
      this.generateForm.get('txtCRNNo').reset();
      this.isGenerateFormSubmitted = false;

    } else if (itemsType === 'BAG') {
      if (!selectedBagId) return this.appCoreService.showMessage('No bag selected to add to list', 'Error', 'error');
      let currentSelected = this.reservebagsList.filter(x => x.id === selectedBagId);
      this.populateBagGrid(currentSelected[0]);
      this.selectedBagsList = this.selectedBagsList.map(element => {
        if (element.id === selectedBagId) {
          return { ...element, isactive: true };
        } else {
          return { ...element, isactive: false };
        }
      });
      this.bagsList = this.bagsList.filter(x => x.id != selectedBagId);
      this.changeDetectorRef.detectChanges();
      this.generateForm.get('ddlBagNo').reset();
      setTimeout(() => {
        this.bagNoRef.focus();
      }, 300);
    }

    // freeze manifest for
    this.manifestForm.get('manifestFor').disable();
    this.manifestForm.get('ddlServiceCenter').disable();
    this.manifestForm.get('ddlVendor').disable();
  }


  populateBagGrid(bag: any) {
    this.bagGridObj = {
      id: bag.id,
      bagno: bag.bagno,
      awbcount: bag.awbnumberscnt,
      weight: 0,
      numbers: [],
      awbnumbers: []
    };

    let bagWeight = 0;

    for (const item of bag?.awbnumbers || []) {
      const awbDetail = bag?.numbers?.find(n => n.awbnumber === item);
      if (awbDetail) {
        const actualWeight = Number(awbDetail.actualweight) || 0;
        bagWeight += actualWeight;
        this.bagGridObj.numbers.push({ awbnumber: awbDetail.awbnumber, actualweight: actualWeight });
        this.bagGridObj.awbnumbers.push(awbDetail.awbnumber);

      }
    }
    this.bagGridObj.weight = bagWeight;
    this.bagGridObj.isactive = true;

    this.selectedBagsList = [...this.selectedBagsList, Object.assign({}, this.bagGridObj)];
    this.rowDataLatestBagDetail = this.bagGridObj.numbers;
  }


  onCheckBoxChange(event?: any) {
    if (event && event != '') {
      this.rowDataLatestBagDetail = [];
      const formattedResult = this.selectedBagsList.map((item: any, index) => ({
        ...item,
        isactive: index === event?.data?.rowIndex && event.checked
      }));
      this.selectedBagsList = formattedResult;

      if (event.checked) {
        this.rowDataLatestBagDetail = event?.rowdata.numbers;
      }
    }
  }

  async getManifestById() {
    if (this.manifestId) {
      this.ngxLoaderService.start();
      this.manifestService.GetById(this.manifestId).subscribe(res => {
        if (res?.success && res.data && res.data[0] != null) {
          const resData = res.data[0];
          if (resData.isclosed) {
            this.manifestForm.disable();
            this.flightForm.disable();
            this.viewOnlyPage = true;
            this.context.actionConfig.hideDelete = true;
          }
          // this.manifestForm.get('ddlBranch')?.setValue(parseInt(resData?.generatedfromid));
          this.manifestForm.get('txtDateTime')?.setValue(this.utilities.FormatDateWithTime(0, resData.manifestdate).dateString);
          this.manifestForm.get('ddlLoadVendor')?.setValue(resData?.loadingvendorid);
          this.manifestForm.get('txtRemarks')?.setValue(resData.remarks);
          this.manifestForm.get('ddlCompany')?.setValue(resData.companyid);
          this.manifestForm.get('manifestFor')?.setValue(resData.manifestfor);
          this.manifestForm.get('ddlServiceCenter')?.setValue(resData.servicecenterid);
          this.manifestForm.get('ddlVendor')?.setValue(resData.thirdpartyvendorid);
          !this.viewOnlyPage ? this.updateServiceCenterVendorValidator() : null;

          const vendorOrServiceId = this.manifestForm.get('manifestFor')?.value === 'Service Center' ? resData.servicecenterid : resData.thirdpartyvendorid;
          const vendorOrServiceType = this.manifestForm.get('manifestFor')?.value;

          this.generateForm.get('chkAwbWise')?.setValue(resData.awbwise ? 'awbwise' : 'bagwise');
          this.onChkAwbWiseChange(resData.awbwise);
          // BAG
          if (resData.bags && resData.bags.length) {
            this.bagsList = resData.bags.map((item: any, index) => ({ ...item, isactive: index === 0 }));
            this.rowDataLatestBagDetail = resData.bags[0].numbers;
            this.selectedBagsList = [...this.selectedBagsList, ...this.bagsList];
          }


          // AWB
          if (resData.awbdetails && resData.awbdetails.length) {
            this.selectedAWBList = [...this.selectedAWBList, ...resData.awbdetails.map(awb => ({ ...awb, bookingdate: this.utilities.FormatDateWithTime(0, awb.bookingdate).dateString }))];
          }

          //bind awblist
          this.filteredAwbList = this.awbNoList
            ?.filter(item => vendorOrServiceType == "Third Party" ?
              item.vendorid === vendorOrServiceId : item.serviceid === vendorOrServiceId)
            ?.map(item => item.awbnumber);

          // this.bindCustomDetails(resData);

          if (resData.isclosed) {
            this.manifestForm.disable();
            this.flightForm.disable();
            this.viewOnlyPage = true;
            if (resData?.length) resData.awbdetails.forEach(awb => { awb.hideDelete = true });
          }

          const flightdetails = resData.flightdetails;

          this.flightForm.patchValue({
            txtFlight1: this.flightList.find(flight => flight.name === flightdetails?.flight1no),
            txtFlight1ArrivalDate: this.utilities.FormatDateWithTime(0, flightdetails?.flight1arrivaldate).dateTimeString,
            txtFlight2: this.flightList.find(flight => flight.name === flightdetails?.flight2no),
            txtFlight2ArrivalDate: this.utilities.FormatDateWithTime(0, flightdetails?.flight2arrivaldate).dateTimeString,
            txtAirlinePrefix: flightdetails?.masterno.airlinePrefix,
            txtAwbSeries1: flightdetails?.masterno.AWBSeries1,
            txtAwbSeries2: flightdetails?.masterno.AWBSeries1,
            txtCDNo: flightdetails?.cdno,
            txtEDIMasterNo: flightdetails?.edimasterno
          })

          this.onEnterFlightSeries();
          this.changeDetectorRef.detectChanges();
          this.ngxLoaderService.stop();
        }
      });
    }
  }

  getAllFlights() {
    this.miscService.GetAllFlights().subscribe(res => {
      if (res && res.success) {
        this.flightList = res.data;
      }
    })
  }

  async getAllBags() {
    const res = await lastValueFrom(this.manifestService.GetAllBags(this.selectedSCId));
    if (res && res?.success) {
      this.reservebagsList = res.data;
      this.bagsList = res.data;
      // console.log('bagsList',this.bagsList);

      // fill its numbers data with looping awbList
      // this.bagsList.forEach(bag => {
      //   if (bag.awbnumbers?.length) {
      //     const matchingAwbs = this.awbNoList.filter(awb => bag.awbnumbers.includes(awb.awbnumber)).map(awb => {
      //       if (awb.actualweight === null || awb.actualweight === "") {
      //         awb.actualweight = 0.00;
      //       }
      //       if (awb.volumetricweight === null || awb.volumetricweight === "") {
      //         awb.volumetricweight = 0.00;
      //       }
      //       return awb;
      //     });
      //     bag.numbers = matchingAwbs.length > 0 ? matchingAwbs : null;
      //   }
      // });
    }
  }

  filterAWBDestination() {
    const countryisocode = this.manifestForm.get('filterDeastinationForm.ddlDestinationCountry')?.value;
    const stateisocode = this.manifestForm.get('filterDeastinationForm.ddlDestinationState')?.value;
    const cityisocode = this.manifestForm.get('filterDeastinationForm.ddlDestinationCity')?.value;

    let filteredList = this.reservedAWBList;
    if (countryisocode) {

      //   countryisocode
      //   ? this.onCountryChange(this.manifestForm, 'filterDeastinationForm', 'destination')
      //   : stateisocode
      //     ? this.onStateChange(this.manifestForm, 'filterDeastinationForm', 'destination')
      //     : null;

      if (countryisocode && stateisocode && cityisocode) {
        filteredList = filteredList.filter(awb =>
          awb.consigneecountryisocode === countryisocode &&
          awb.consigneestateisocode === stateisocode &&
          awb.consigneecityisocode === cityisocode
        );
      } else if (countryisocode && stateisocode) {
        filteredList = filteredList.filter(awb =>
          awb.consigneecountryisocode === countryisocode &&
          awb.consigneestateisocode === stateisocode
        );
      } else if (countryisocode) {
        filteredList = filteredList.filter(awb =>
          awb.consigneecountryisocode === countryisocode
        );
      }
      this.awbNoList = filteredList;
      if (!filteredList.length) {
        this.appCoreService.showMessage('Clear Filter to get all Air Waybills', 'No Air Waybills found', "error");
        setTimeout(() => {
          this.countryRef.focus();
        }, 200);
      } else {
        this.awbNoList = filteredList;
        this.appCoreService.showMessage('Please enter Air Waybill no.', 'Air Waybills found', "success");
        this.generateForm.get('txtAwbOrForwardingNo').reset();
        setTimeout(() => {
          this.awbNoInput.nativeElement.focus();
        }, 200);
      }
    } else {
      this.awbNoList = filteredList;
      this.appCoreService.showMessage('Please select country', 'No filter applied', "error");
      setTimeout(() => {
        this.countryRef.focus();
      }, 200);
    }
  }

  clearFilter() {
    this.manifestForm.get('filterDeastinationForm.ddlDestinationCountry').reset();
    this.manifestForm.get('filterDeastinationForm.ddlDestinationState').reset();
    this.manifestForm.get('filterDeastinationForm.ddlDestinationCity').reset();
    this.awbNoList = this.reservedAWBList;
    this.appCoreService.showMessage('Please Enter AWB no. to manifest', 'All Filter Cleared');
    this.generateForm.get('txtAwbOrForwardingNo').reset();
  }

  onCountryChange(form: FormGroup, formGroupName?: string, changeType?: 'origin' | 'destination') {
    let countryCode: any;
    let stateControlName: string;
    let cityControlName: string;

    if (changeType === 'origin') {
      if (formGroupName) {
        countryCode = form.get(`${formGroupName}.ddlOriginCountry`)?.value;
        stateControlName = `${formGroupName}.ddlOriginState`;
        cityControlName = `${formGroupName}.ddlOriginCity`;
      } else {
        countryCode = form.get('ddlOriginCountry')?.value;
        stateControlName = 'ddlOriginState';
        cityControlName = 'ddlOriginCity';
      }

      this.originCityList = [];
    } else {
      if (formGroupName) {
        countryCode = form.get(`${formGroupName}.ddlDestinationCountry`)?.value;
        stateControlName = `${formGroupName}.ddlDestinationState`;
        cityControlName = `${formGroupName}.ddlDestinationCity`;
      } else {

        countryCode = form.get('ddlDestinationCountry')?.value;
        stateControlName = 'ddlDestinationState';
        cityControlName = 'ddlDestinationCity';
      }

      this.destinationCityList = [];
    }

    form.get(stateControlName)?.reset();
    form.get(cityControlName)?.reset();

    this.bindStatesByCountry(countryCode, changeType === 'origin' ? 'origin' : 'destination');
    this.bindCitiesByCountry(countryCode, changeType === 'origin' ? 'origin' : 'destination');
  }

  onStateChange(form: FormGroup, formGroupName?: string, changeType?: 'origin' | 'destination') {
    let countryCode: any;
    let stateCode: any;
    let cityControlName: string;

    if (changeType === 'origin') {
      if (formGroupName) {
        countryCode = form.get(`${formGroupName}.ddlOriginCountry`)?.value;
        stateCode = form.get(`${formGroupName}.ddlOriginState`)?.value;
        cityControlName = `${formGroupName}.ddlOriginCity`;
      } else {
        countryCode = form.get('ddlOriginCountry')?.value;
        stateCode = form.get('ddlOriginState')?.value;
        cityControlName = 'ddlOriginCity';
      }

      this.originCityList = [];
    } else {
      if (formGroupName) {
        countryCode = form.get(`${formGroupName}.ddlDestinationCountry`)?.value;
        stateCode = form.get(`${formGroupName}.ddlDestinationState`)?.value;
        cityControlName = `${formGroupName}.ddlDestinationCity`;
      } else {
        countryCode = form.get('ddlDestinationCountry')?.value;
        stateCode = form.get('ddlDestinationState')?.value;
        cityControlName = 'ddlDestinationCity';
      }

      this.destinationCityList = [];
    }

    form.get(cityControlName)?.reset();
    if (stateCode) {
      this.bindCitiesByState(stateCode, changeType);
    }
    else {
      this.bindCitiesByCountry(countryCode, changeType)
    }
  }


  flightFormatter = (x: any) => x.name;
  awbDetailsFormatter = (x: any) => x.awbnumber;

  searchFlight: OperatorFunction<string, readonly { name; flag }[]> = (text$: Observable<string>) =>
    text$.pipe(
      debounceTime(200),
      distinctUntilChanged(),
      map((term) =>
        term === ''
          ? []
          : this.flightList.filter((x) => x.name.toLowerCase().indexOf(term.toLowerCase()) > -1).slice(0, 10),
      ),
    );

  searchAWBNumber: OperatorFunction<string, readonly { awbnumber; flag }[]> = (text$: Observable<string>) =>
    text$.pipe(
      debounceTime(200),
      distinctUntilChanged(),
      map((term) =>
        term === ''
          ? []
          : this.awbNoList?.filter((x) => x.awbnumber.toLowerCase().indexOf(term.toLowerCase()) > -1).slice(0, 10),
      ),
    );


  onEnterFlightSeries() {
    let airlinePrefix = this.flightForm.get('txtAirlinePrefix').value?.toString().replace(/\D/g, '').padStart(4, '') ?? '';
    let series1 = this.flightForm.get('txtAwbSeries1').value?.toString().replace(/\D/g, '').padStart(4, '') ?? '';
    let series2 = this.flightForm.get('txtAwbSeries2').value?.toString().replace(/\D/g, '').padStart(4, '') ?? '';

    // Truncate values to a maximum length of 4 characters
    airlinePrefix = airlinePrefix.slice(0, 4);
    series1 = series1.slice(0, 4);
    series2 = series2.slice(0, 4);

    // Update form controls with truncated values
    this.flightForm.get('txtAirlinePrefix').setValue(airlinePrefix);
    this.flightForm.get('txtAwbSeries1').setValue(series1);
    this.flightForm.get('txtAwbSeries2').setValue(series2);

    let masterAwbNo = airlinePrefix;

    if (series2?.trim() === '') {
      masterAwbNo = masterAwbNo.concat(series1);
    } else {
      masterAwbNo = masterAwbNo.concat(series1, series2);
    }
    this.masterAwbNo = masterAwbNo;
  }

  onChkAwbWiseChange(show) {
    this.showAwbWise = show;
    setTimeout(() => {
      show ? this.awbNoInput.nativeElement.focus() : this.bagNoRef.focus();
    }, 500);
  }

  async deleteAction(cell: any) {
    if (!this.permConfig.isDeleteAllowed) {
      this.errAlert('No Access to Delete.');
    }
    if (!this.viewOnlyPage) {
      const confirmed = await this.openConfirmationDialog('Are you sure you want to delete ?');
      if (confirmed) {
        if (this.showAwbWise) {
          this.awbNoList = [
            ...this.awbNoList,
            ...this.selectedAWBList.filter(x =>
              x.awbnumber === cell.awbnumber && !this.awbNoList.some(awb => awb.awbnumber === cell.awbnumber)
            )
          ].sort((a, b) => {
            const awbNumberA = parseInt(a.awbnumber.split('-')[1] || '0', 10);
            const awbNumberB = parseInt(b.awbnumber.split('-')[1] || '0', 10);

            return awbNumberA - awbNumberB;  // Sorting numerically
          });

          this.selectedAWBList = this.selectedAWBList.filter(item => item.awbnumber != cell.awbnumber);
        } else {
          this.selectedBagsList = this.selectedBagsList.filter(item => item.id != cell.id);
          // console.log('selectedBagsList',this.selectedBagsList);

          //put back into bagslist
          const filteredBags = this.reservebagsList.filter(item => item.id === cell.id);
          this.bagsList = filteredBags.length ? [...this.bagsList, ...filteredBags] : [...this.bagsList];

          this.rowDataLatestBagDetail = []

          //populated selected bag awb with weight
          // if (this.selectedBagsList.length) {
          //   let currentSelected = this.reservebagsList.filter(x => x.id != cell.id);
          //   // this.selectedBagsList = []
          //   // this.populateBagGrid(currentSelected[0]);
          // }
        }
      }
    }
  }

  async openAWBConfirmationDialog(arrayParam: any[]) {
    this.isDialogOpen = true; // Set flag before opening dialog

    const result = await Swal.fire({
      title: 'Confirmation',
      html: `<h5>This is a <b>Master AWB</b> number.</h5>
            <h5>Do you want to manifest all its <b>child-AWB</b> numbers?</h5>`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes. Select All',
      cancelButtonText: 'No. Select individually.',
      allowEnterKey: false,
      allowEscapeKey: false,
      allowOutsideClick: false,
      showCloseButton: true,  // ✅ Enables close button
      didOpen: () => {
        const confirmButton = Swal.getConfirmButton();
        if (confirmButton) {
          confirmButton.focus();
        }
      }
    });

    this.isDialogOpen = false; // Reset flag after dialog closes

    let tempSelectedArray: any[];

    if (result.isConfirmed) {
      // ✅ User clicked "Yes. Select All"
      tempSelectedArray = arrayParam.flatMap(item => item.awbnumber);
    } else if (result.dismiss === Swal.DismissReason.cancel) {
      // ✅ User clicked "No. Select individually."
      tempSelectedArray = await this.openChildAWBModel(arrayParam);
    } else if (result.dismiss === Swal.DismissReason.close) {
      // ✅ User clicked the (×) close button, do nothing (dialog just closes)
      console.log('Dialog closed using the cross button');
      return;
    }
    let selectedChildList = [];
    for (const awb of tempSelectedArray) {
      let selectedawb: any = this.awbNoList.filter(x => x.awbnumber === awb);
      selectedawb[0].crnnumber = this.crnnumber;
      this.awbNoList = this.awbNoList.filter(item => item.awbnumber != awb);
      let parentAwbNumber = selectedawb[0]?.parentawbnumber;
      if (parentAwbNumber) {
        let hasChildren = this.awbNoList.some(item => item.parentawbnumber === parentAwbNumber);
        if (!hasChildren) {
          // Remove the parent AWB as well if no children are left
          this.awbNoList = this.awbNoList.filter(item => item.awbnumber !== parentAwbNumber);
        }
      }
      let itemIdx = this.selectedAWBList.findIndex(x => x.awbnumber === selectedawb[0].awbnumber);
      if (itemIdx < 0) {
        selectedChildList.push(selectedawb[0]);
      }

    }
    // remove duplicate selections
    // selectedChildList = selectedChildList.map((val, idx) => {
    //   return (this.selectedAWBList.findIndex(x => x.awbnumber === val.awbnumber) < 0
    //         ?? val);

    // });
    // for (const awb of selectedChildList) {
    //   let itemIdx = this.selectedAWBList.findIndex(x => x.awbnumber === awb.awbnumber);
    //   if (itemIdx > 0) {
    //     selectedChildList.splice(itemIdx);
    //   }
    // }


    this.selectedAWBList = [...this.selectedAWBList, ...selectedChildList];
    // Ensure UI updates before focusing
    this.changeDetectorRef.detectChanges();
    setTimeout(() => {
      this.isGenerateFormSubmitted = false;
      this.awbNoInput.nativeElement.focus();
    }, 400);
    // console.log(this.selectedAWBList);
    // this.awbNoArray = this.rowDataAwbWise.flatMap(item => item.awbnumber);
    // this.awbNoArray = [...this.awbNoArray, ...tempSelectedArray];
    // this.insertItemToBag(this.awbNoArray);
  }

  async openChildAWBModel(childAWBList: any[]): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      let ngbModalOptions: NgbModalOptions = {
        ariaLabelledBy: 'modal-basic-title',
        size: 'md',
        backdrop: 'static',
        keyboard: false,
        centered: true
      };
      const modalRef = this.modalService.open(ChildAWBGridComponent, ngbModalOptions);
      modalRef.componentInstance.childAWBNoList = childAWBList;

      modalRef.result.then(
        (result) => {
          if (result) {
            resolve(result);
          } else {
            resolve(null);
          }
        },
        (reason) => {
        }
      );
    });
  }

  async openConfirmationDialog(msg: any) {
    const result = await Swal.fire({
      title: 'Warning!',
      text: msg,
      icon: 'warning',
      confirmButtonText: 'Yes',
      cancelButtonText: 'No',
      showCancelButton: true,
      allowEscapeKey: false,
      allowOutsideClick: false,
      allowEnterKey: true
    })
    if (result.isConfirmed) {
      return true;
    } else return false;
  }


  async onSelectForwardingORAwbNo(fieldType?: string) {
    if (fieldType === 'awb') {
      this.generateForm.get('txtAwbOrForwardingNo').reset();
    }
    if (fieldType === 'forwarding') {
      const awbnumber = this.forwardingAwbList.find(x => x.forwardingawbno === this.generateForm.get('txtAwbOrForwardingNo').value)?.awbnumber;
      this.generateForm.get('txtAwbOrForwardingNo').setValue(this.awbNoList.find(item => item.awbnumber === awbnumber));
    }
  }

  bindCountries() {
    try {
      this.geoService.GetAllCountries().subscribe((res) => {
        if (res && res.success) {
          this.countryList = res.data;
        }
      });
    } catch (e) {
      console.error(e);
    }
  }

  async bindStatesByCountry(countryCode?: string, type?: any): Promise<void> {
    try {
      if (countryCode) {
        const observable = this.geoService.GetAllStates({ countrycode: countryCode });
        const res = await lastValueFrom(observable);
        if (res && res.success) {
          // this.countryCode = countryCode;
          if (type === 'origin') {
            this.originStateList = res.data;

          } else {
            this.destinationStateList = res.data;
          }
        }
      }
    } catch (error) {
      console.error(error);
      throw error;
    }
  }

  async bindCitiesByCountry(countryIsoCode?: string, type?: any): Promise<void> {
    try {
      if (countryIsoCode) {
        const observable = this.geoService.GetAllCities({ countryisocode: countryIsoCode });
        const res = await lastValueFrom(observable);
        if (res && res.success) {
          // this.countryCode = countryCode;
          if (type === 'origin') {
            this.originCityList = res.data;

          } else {
            this.destinationCityList = res.data;
          }
        }
      }
    } catch (error) {
      console.error(error);
      throw error;
    }
  }

  async bindCitiesByState(stateCode?: string, type?: any): Promise<void> {
    try {
      if (stateCode) {
        const observable = this.geoService.GetAllCities({ statecode: stateCode });
        const res = await lastValueFrom(observable);
        if (res && res.success) {
          if (type === 'origin') {
            this.originCityList = res.data;
          } else {
            this.destinationCityList = res.data;
          }
        }
      }
    } catch (e) {
      console.error(e);
    }
  }

  getAwbDetailsById() {
    if (this.manifestId != null) {
      this.ngxLoaderService.start();
      try {
        this.manifestService.GetAwbDetailsById(this.manifestId).subscribe((res) => {
          if (res && res.success) {
            this.ngxLoaderService.stop();
            for (const item of res.data) {
              item.bookingdate = this.utilities.formatDate(item.bookingdate).dateString;
              item.hideDelete = this.viewOnlyPage;
            }
            this.rowDataAwbWise = res.data.map(x => ({ ...x, bagnumber: !x.bagnumber ? '-' : x.bagnumber }))
            this.manifestedAWbs = this.rowDataAwbWise;

            // this.onChangeSummaryView(true);
          }
        })
      } catch (e) {
        console.error(e);
        this.ngxLoaderService.stop();
      }
    }
  }

  onGridReady(params: GridReadyEvent) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    this.gridApi.setDomLayout("autoHeight");
    this.gridApi.sizeColumnsToFit();
  }

  addManifest() {
    this.manifestFormSubmitted = true;
    if (!this.permConfig.isAddAllowed) {
      this.errAlert('No Access to Add.');
      return;
    }


    if (this.manifestForm.invalid) {
      // Retrieve the keys of invalid form controls
      const invalidControls = Object.keys(this.manifestForm.controls).filter(key => this.manifestForm.controls[key].invalid);
      // console.log('Invalid form controls:', invalidControls);
      return;
    }

    // if (this.showawbDetailsForm) {
    //   this.awbDetailsFormSubmitted = true;
    //   if (this.awbDetailsForm.invalid) {
    //     return;
    //   }
    // }
    if (!this.selectedAWBList.length && this.showAwbWise) {
      this.appCoreService.showMessage('Manifest cannot be empty.', 'Error', 'error');
      return;
    } else if (!this.selectedBagsList.length && !this.showAwbWise) {
      this.appCoreService.showMessage('Manifest cannot be empty.', 'Error', 'error');
      return;
    }

    if (this.manifestForm.valid) {
      const flightControls = this.flightForm.controls;
      const flightDetails = {
        flight1No: flightControls['txtFlight1'].value,
        flight1ArrivalDate: flightControls['txtFlight1ArrivalDate'].value,
        flight2No: flightControls['txtFlight2'].value,
        flight2ArrivalDate: flightControls['txtFlight2ArrivalDate'].value,
        CDNo: flightControls['txtCDNo'].value,
        EDIMasterNo: flightControls['txtEDIMasterNo'].value,
        masterNo: {
          airlinePrefix: flightControls['txtAirlinePrefix'].value,
          AWBSeries1: flightControls['txtAwbSeries1'].value,
          AWBSeries2: flightControls['txtAwbSeries2'].value,
        },
        masterAWBNo: this.masterAwbNo
      }
      // Assuming your first dataset is stored in 'firstData' and the second dataset is stored in 'secondData'


      // Now, firstData will have the childawbid property added to each object if it exists in secondData

      const reqObj = {
        id: this.manifestId,
        generatedfromid: this.selectedSCId,
        manifestdate: this.manifestForm.get('txtDateTime')?.value,
        manifestfor: this.manifestForm.get('manifestFor')?.value,
        servicecenterid: this.manifestForm.get('ddlServiceCenter')?.value,
        thirdpartyvendorid: this.manifestForm.get('ddlVendor')?.value,
        loadingvendorid: this.manifestForm.get('ddlLoadVendor')?.value,
        remarks: this.manifestForm.get('txtRemarks')?.value,
        companyid: this.manifestForm.get('ddlCompany')?.value,
        flightdetails: flightDetails,
        // awbdetails: this.rowDataAwbWise.map(x => ({ ...x, bagnumber: x.bagnumber === '-' ? null : x.bagnumber }))
        awbwise: this.showAwbWise,
        itemstype: this.showAwbWise === true ? 'awb' : 'bag',
        awbdetails: this.selectedAWBList,
        bags: this.selectedBagsList
      }


      // reqObj.awbdetails.forEach(item => {
      //   // Check if any item in childAWBNoList has a matching awbnumber in its childawb_array
      //   const match = this.childAWBNoList?.find(obj => obj.childawb_array.some(child => child.childawbno === item.awbnumber));

      //   if (match) {
      //     // Find the matching child object in the childawb_array
      //     const childMatch = match.childawb_array.find(child => child.childawbno === item.awbnumber);

      //     // Assign the childawbid from the child object to item.childawbid
      //     item.childawbid = childMatch.childawbid;
      //   }
      // });
      // // console.log('manifestedAWbs',this.manifestedAWbs);
      // reqObj.awbdetails = reqObj.awbdetails.filter(awb => !this.manifestedAWbs.some(restored => restored.awbnumber === awb.awbnumber));


      this.ngxLoaderService.start();
      this.manifestService.Add(reqObj).subscribe(async (res) => {
        if (res && !res.success) {
          this.ngxLoaderService.stop();
          if (res.message.isexists_err_msg) {
            const err_obj = res.message.isexists_err_msg.map(x => x.msg).join('<br>');
            await Swal.fire({
              icon: 'warning',
              title: 'Oops...',
              html: '<h4>Some Shipments are already manifested.</h4><br>' + err_obj,
            });
            return;
          }
          return;
        } else if (res && res.success) {
          this.ngxLoaderService.stop();
          await this.openSuccessDialog('Record Saved Successfully.');
          this.resetManifestForm();
          // If not exists i.e. created, assign id
          this.manifestForm.controls.txtDateTime.disable();
          this.manifestId = res?.data?.id;
          this.router.navigate(['/operation/manifests']);
        }
      });
    }
  }

  async getAllAvailableAwb() {
    try {
      const res = await lastValueFrom(this.awbService.getAwbReceivedList(this.selectedSCId));
      if (res?.success) {
        let parseAwbList: any[] = res.data;

        parseAwbList = parseAwbList.map(obj => ({
          ...obj,
          bookingdate: this.utilities.formatDate(obj.bookingdate)?.dateString || obj.bookingdate,
          volumetricweight: obj.volumetricweight == "" ? 0 : obj.volumetricweight
        }));

        this.awbNoList = parseAwbList;
        this.reservedAWBList = parseAwbList;

        // console.log('this.awbNoList', this.awbNoList);
      }

    } catch (e) {
      console.log("Error:", e);
    }
  };


  onChangeField(event?: any, type?: string) {
    this.selectedVendorid = this.manifestForm.controls.ddlVendor.value;
    this.selectedServiceid = this.manifestForm.controls.ddlServiceCenter.value;
    if (event?.id) {
      this.filteredAwbList = this.awbNoList?.filter(item => type == "Third Party" ? item.vendorid === event.id : item.serviceid === event.id)
        .map(item => item.awbnumber);
    }
    else if (this.manifestForm.controls.manifestFor.value === 'Third Party') {
      this.filteredAwbList = this.awbNoList?.filter(item => item.vendorid == this.selectedVendorid).map(item => item.awbnumber);
    }
    else {
      this.filteredAwbList = this.awbNoList?.filter(item => item.serviceid === this.selectedServiceid).map(item => item.awbnumber);
    }
  }

  getServiceCenters() {
    try {
      this.networkService.GetAllServiceCenters({ isactive: true }).subscribe((res) => {
        if (res && res.success) {
          // Extract all allowed service center IDs from `allowedscformanifest`
          const allowedScListforCurrentSc = res.data
            .map(sc => sc.allowedscformanifest || [])
            .flat();

          // Bind only those service centers whose IDs are in `allowedScListforCurrentSc`
          this.serviceCenterList = res.data.filter(sc => allowedScListforCurrentSc.includes(sc.id) && sc.id !== this.selectedSCId);
        }
      });
    } catch (error) {
      console.error(error);
    }
  }


  getAllVendors() {
    try {
      this.vendorService.GetAll({ isactive: true }).subscribe((res) => {
        if (res && res.success) {
          this.vendorList = res.data;
        }
      });
    } catch (err) {
      console.error(err);
    }
  }
  // ----------------------------------------------------------------------------------------------------------------------------------------

  addAWBDetails(callback) {
    this.generateRowsOrSave();
    if (this.awbDetailsForm.invalid) {
      if (this.piecesMandate && this.awbDetailsForm.get('txtPieces')?.value <= 0) {
        this.errAlert("Please Provide Pieces Details !");
      }
      return;
    }
    this.insertIntoFinalList();
    if (this.piecesMandate && this.awbDetailsForm.get('txtPieces')?.value !== null) {
      let msg = "";
      this.piecesDetailsList.map(function (x, i) {
        if ((x.actualweight == null || x.actualweight == 0) && msg == "") {
          msg = "Actual Weight is mandatory at Box.No -" + (i + 1);
          return;
        }
      });

      if (msg) {
        this.errAlert(msg);
        return;
      }
    }

    const pieces = {
      id: null,
      piecesnumber: this.awbDetailsForm.get('txtPieces')?.value,
      pieceunit: this.awbDetailsForm.get('ddlPiecesUnit')?.value,
      actualweight: this.awbDetailsForm.get('txtTotalActualWeight')?.value,
      volumetricweight: this.awbDetailsForm.get('txtTotalVolumetricWeight')?.value,
      chargeableweight: this.awbDetailsForm.get('txtTotalChargeableWeight')?.value,
      piecesDetails: this.finalList,
    };

    let details = [];
    const shipper = this.awbDetailsForm.get('txtShipper')?.value;
    const consignee = this.awbDetailsForm.get('txtConsignee')?.value;
    let shipperArea = this.awbDetailsForm.get('shipperlocationdetails')?.get('txtArea')?.value;
    shipperArea = (typeof shipperArea === 'string') ? shipperArea : shipperArea.area;
    let consigneeArea = this.awbDetailsForm.get('consigneelocationdetails')?.get('txtArea')?.value;
    consigneeArea = (typeof consigneeArea === 'string') ? consigneeArea : consigneeArea.area;

    let shipperPincode = this.awbDetailsForm.get('shipperlocationdetails')?.get('txtPincode')?.value;
    shipperArea = (typeof shipperPincode === 'string') ? shipperPincode : shipperPincode.pincode;
    let consigneePincode = this.awbDetailsForm.get('consigneelocationdetails')?.get('txtPincode')?.value;
    consigneePincode = (typeof consigneePincode === 'string') ? consigneePincode : consigneePincode.pincode;

    if (typeof shipper === 'string' || shipper instanceof String) {
      details.push({
        info: {
          type: 'Shipper',
          name: shipper,
          contactperson: this.awbDetailsForm.get('txtShipperPerson').value,
          emailid: this.awbDetailsForm.get('txtShipperEmail').value,
          status: true,
          location: {
            country: this.awbDetailsForm.get('shipperlocationdetails').get('ddlCountry')?.value,
            state: this.awbDetailsForm.get('shipperlocationdetails').get('ddlState')?.value,
            city: this.awbDetailsForm.get('shipperlocationdetails').get('ddlCity')?.value,
            pincode: shipperPincode,
            address1: this.awbDetailsForm.get('shipperlocationdetails').get('txtAddress1')?.value,
            address2: this.awbDetailsForm.get('shipperlocationdetails').get('txtAddress2')?.value,
            area: shipperArea,
            mobileno: this.awbDetailsForm.get('shipperlocationdetails').get('txtMobileNo')?.value,
            tel: this.awbDetailsForm.get('shipperlocationdetails').get('txtTelephoneNo')?.value
          }
        },
      });
    } else {
      details.push({
        info: {
          type: 'Shipper',
          id: shipper?.id,
          code: shipper?.code,
          name: shipper?.name,
          location: shipper?.location
        },
      });
    }

    if ((typeof consignee === 'string' || consignee instanceof String)) {
      details.push({
        info: {
          type: 'Consignee',
          name: consignee,
          contactperson: this.awbDetailsForm.get('txtShipperPerson').value,
          emailid: this.awbDetailsForm.get('txtShipperEmail').value,
          status: true,
          location: {
            country: this.awbDetailsForm.get('consigneelocationdetails').get('ddlCountry')?.value,
            state: this.awbDetailsForm.get('consigneelocationdetails').get('ddlState')?.value,
            city: this.awbDetailsForm.get('consigneelocationdetails').get('ddlCity')?.value,
            pincode: consigneePincode,
            address1: this.awbDetailsForm.get('consigneelocationdetails').get('txtAddress1')?.value,
            address2: this.awbDetailsForm.get('consigneelocationdetails').get('txtAddress2')?.value,
            area: this.awbDetailsForm.get('consigneelocationdetails').get('txtArea')?.value?.area,
            mobileno: this.awbDetailsForm.get('consigneelocationdetails').get('txtMobileNo')?.value,
            tel: this.awbDetailsForm.get('consigneelocationdetails').get('txtTelephoneNo')?.value
          }
        },
      });
    } else {
      details.push({
        info: {
          type: 'Consignee',
          id: consignee?.id,
          code: consignee?.code,
          name: consignee?.name,
          location: consignee?.location
        },
      });
    }
    const reqObj = {
      id: null,
      awbnumber: this.awbNumber,
      bookingdate: this.awbDetailsForm.get('txtAwbDate')?.value,
      customerid: this.awbDetailsForm.get('ddlCustomer')?.value,
      consigneeaddressbookid: this.consigneeaddressbookid,
      productid: this.awbDetailsForm.get('txtProduct')?.value,
      vendorid: this.awbDetailsForm.get('txtVendor')?.value,
      serviceid: this.awbDetailsForm.get('ddlVendorService')?.value,
      paymentmode: this.awbDetailsForm.get('ddlPaymentMode')?.value,
      shipmentvalue: this.awbDetailsForm.get('txtShipmentValue')?.value,
      actualweight: this.awbDetailsForm.get('txtTotalActualWeight')?.value,
      actualweightunit: this.awbDetailsForm.get('ddlPiecesUnit')?.value,
      pieces: pieces,
      details
    };
    this.awbService.AddAWB(reqObj).subscribe((res) => {
      try {
        callback(res);
      } catch (err) {
        console.error(err);
      }
    });
  }

  generateRowsOrSave() {
    if (this.awbDetailsForm.get('txtPieces')?.value > 50) {
      this.errAlert("Please Enter Pieces Upto 50");
      return;
    }
    this.numberOfRowsToGenerate = this.awbDetailsForm.get('txtPieces')?.value - this.piecesDetailsList.length;
    for (let i = 0; i < (this.numberOfRowsToGenerate); i++) {
      const newRow = {
        piecelength: null,
        piecebreadth: null,
        pieceheight: null,
        actualweight: null,
        volumetricweight: null,
        chargeweight: null,
      };
      this.piecesDetailsList.push(newRow);
    }
  }

  deleteRow(index: any) {
    if (this.piecesDetailsList.length == 1) {
      this.errAlert("Only one record exists — do not delete!")
      return;
    }
    this.piecesDetailsList.splice(index, 1);
    this.awbDetailsForm.get('txtPieces')?.setValue(this.piecesDetailsList.length);
    this.calculatePiecesDetails();
  }

  insertIntoFinalList() {
    const finalList: any[] = [];
    for (const item of this.piecesDetailsList) {
      if (item.actualweight !== null) {
        finalList.push(item);
      }
    }
    this.finalList = finalList;
  }

  calculateTotalWVC() {
    this.awbDetailsForm.get('txtTotalChargeableWeight')?.setValue(
      Math.max(this.awbDetailsForm.get('txtTotalActualWeight').value,
        this.awbDetailsForm.get('txtTotalVolumetricWeight').value))
  }

  calculatePiecesDetails(piecesfldDet?) {
    const division = this.awbDetailsForm.get('ddlPiecesUnit')?.value === 'in' ? 2000 : 5000;
    if (!piecesfldDet) {
      piecesfldDet = this.piecesDetailsList[0];
    }
    if (this.awbDetailsForm.get('txtPieces')?.value === null || this.awbDetailsForm.get('txtPieces')?.value <= 0) {
      return this.errAlert('Please fill number of pieces!');
    }
    let totalActualWeight = 0;
    let totalVolumetricWeight = 0;
    const actualweight: any = parseFloat(piecesfldDet.actualweight || 0);
    const lengthValue = parseFloat(piecesfldDet.piecelength || 0);
    const breadthValue = parseFloat(piecesfldDet.piecebreadth || 0);
    const heightValue = parseFloat(piecesfldDet.pieceheight || 0);
    piecesfldDet.volumetricweight = (lengthValue * breadthValue * heightValue) / division;
    piecesfldDet.chargeableweight = Math.max(piecesfldDet.volumetricweight, parseFloat(actualweight));
    for (const item of this.piecesDetailsList) {
      totalActualWeight += parseFloat(item.actualweight || 0);
      totalVolumetricWeight += parseFloat(item.volumetricweight || 0);
    }
    this.awbDetailsForm.get('txtTotalActualWeight')?.setValue(totalActualWeight);
    this.awbDetailsForm.get('txtTotalVolumetricWeight')?.setValue(totalVolumetricWeight);
    this.awbDetailsForm.get('txtTotalChargeableWeight')?.setValue(Math.max(totalActualWeight, totalVolumetricWeight));
    this.insertIntoFinalList();
  }

  updateServiceCenterVendorValidator() {
    this.manifestFor = this.manifestForm.get('manifestFor')?.value;

    if (this.manifestFor === 'Service Center') {
      this.manifestForm.controls.ddlVendor.reset();
      this.manifestForm.get('ddlServiceCenter').setValidators([Validators.required]);
      this.manifestForm.get('ddlVendor').clearValidators();
      this.showVendors = false;
    } else {
      this.manifestForm.controls.ddlServiceCenter.reset();
      this.manifestForm.get('ddlServiceCenter').clearValidators();
      this.manifestForm.get('ddlVendor').setValidators([Validators.required]);
      this.showVendors = true;
    }
    this.manifestForm.get('ddlServiceCenter').updateValueAndValidity();
    this.manifestForm.get('ddlVendor').updateValueAndValidity();
    this.onChangeField();
  }

  errAlert(msg: any) {
    Swal.fire({
      icon: 'warning',
      title: 'Oops...',
      text: msg,
      allowEscapeKey: false,
      allowOutsideClick: false
    });
  }

  search: OperatorFunction<string, readonly { name; flag }[]> = (text$: Observable<string>) =>
    text$.pipe(
      debounceTime(200),
      distinctUntilChanged(),
      map((term) =>
        term === ''
          ? []
          : this.addressBookList.filter((v) => v.name.toLowerCase().indexOf(term.toLowerCase()) > -1).slice(0, 10),
      ),
    );

  selectedItemEventConsignee(e) {
    try {
      if (e) {
        this.bindconsigneelocationdetails(e.item);
      }
    } catch (error) {

    }
  }

  bindCustomers() {
    try {
      this.customerService.GetAll({ scid: this.appCoreService.GetUserData().selectedServiceCenter, isactive: true }).subscribe((res) => {
        if (res && res.success) {
          this.customerList = res.data;
          const ud: any = this.appCoreService.GetUserData();
          if (ud && ud.accessType == "Customer") {
            this.isAccessTypeCustomer = true;
            this.awbDetailsForm.get('ddlCustomer').setValue(this.customerList.find(x => x.id === ud?.metaInfo?.customerid)?.id);
            this.awbDetailsForm.get('ddlCustomer').disable();
            this.awbDetailsForm.get('txtBookingDate').disable();
            this.bindCustomerShipperInfo();
          }
        }
      });
    } catch (e) {
      console.error(e);
    }
  }

  bindshipperlocationdetails(e) {
    try {
      if (e.item) {
        const currLoc = e.item;
        this.shipperLocationInfo = {
          country: currLoc.location.country,
          state: currLoc.location.state,
          city: currLoc.location.city,
          area: currLoc.location.area,
          address1: currLoc.location.address1,
          address2: currLoc.location.address2,
          pincode: currLoc.location.pincode,
          mobileno: currLoc.location.mobileno,
          tel: currLoc.location.tel,
        };
      }
    }
    catch (e) {
      console.error(e);
    }
  }

  bindconsigneelocationdetails(e) {
    try {
      if (e.item) {
        const currLoc = e.item;
        this.consigneeLocationInfo = {
          country: currLoc.location.country,
          state: currLoc.location.state,
          city: currLoc.location.city,
          area: currLoc.location.area,
          address1: currLoc.location.address1,
          address2: currLoc.location.address2,
          pincode: currLoc.location.pincode,
          mobileno: currLoc.location.mobileno,
          tel: currLoc.location.tel,
        };
      }
    }
    catch (err) {
      console.error(err);
    }
  }

  async bindCustomerShipperInfo() {
    //this.getAWBCharges();
    const customerId = this.awbDetailsForm.get('ddlCustomer')?.value;
    const customerData: any = this.customerList.filter(x => x.id === customerId);

    customerData[0]?.paymenttype ? this.awbDetailsForm.get("ddlPaymentType").setValue(customerData[0].paymenttype) : '';
    if (customerId && customerData[0]?.customertype !== "Co-Courier") {
      this.customerData = customerData;
      this.isShipperCustomerBinded = true;

      this.shipperLocationInfo = {
        ...this.shipperLocationInfo,
        location: customerData?.[0]?.location ?? {},
        info: {
          name: customerData?.[0]?.name,
          emailid: customerData?.[0]?.emailid,
          contactperson: customerData?.[0]?.contactperson
        }
      }

    }
    // else {
    //   this.shipperLocationInfo = {};
    //   this.awbDetailsForm.get('shipperlocationdetails').patchValue({
    //     txtName: null,
    //     txtContactPerson: null,
    //     txtEmail: null,
    //   });

    // }

    // this.volumetricDetails();
    /*if customer change 
      -get enrolled companies with that customer, if list.length then modify this.companyList : else this.companyList 
    */
    //customers having companies --> take companyids
    // this.awbDetailsForm.get('ddlCompanies').reset();

    const filteredCompanyList = this.respCompanyList.filter(company => customerData[0]?.companyids?.includes(company.id));
    this.companyList = filteredCompanyList;
    if (filteredCompanyList.length) {
      let selectedCompany = this.companyList?.length == 1 ? this.companyList[0].id : null;
      // this.awbDetailsForm.get('ddlCompanies').setValue(selectedCompany);
    }

    if (!customerId) {
      let defaultCompany = this.companyList.filter(x => x.isdefault)[0]?.id || null;
      // this.awbDetailsForm.get('ddlCompanies').setValue(defaultCompany);
    }

    if (filteredCompanyList?.length) {
      if (filteredCompanyList?.length == 1) {
        // this.awbDetailsForm.get('ddlCompanies').setValue(filteredCompanyList[0].id);
      } else {
        //if it is default company then select it 
        // this.companyList.filter(x => x.isdefault).length ? this.awbDetailsForm.get('ddlCompanies').setValue(this.companyList[0]?.id) : this.companyList;
        // this.companyList = filteredCompanyList?.length > 1 ? filteredCompanyList : this.respCompanyList;
      }
    } else {
      this.companyList = this.respCompanyList;
    }
  }

  bindAddressBook() {
    try {
      this.addressbookService.GetAll({ isactive: true }).subscribe((res) => {
        if (res && res.success) {
          this.addressBookList = res.data;
        }
      });
    } catch (e) {
    }
  }

  async getAllVendorServices(): Promise<void> {
    const awbDetailsForm = this.awbDetailsForm;
    const id = awbDetailsForm.get('ddlVendor')?.value;
    if (id != null) {
      try {
        const res = await lastValueFrom(this.vendorService.GetAllListByVendor({ id }));
        if (res && res.success) {
          this.vendorServiceList = res.data;
          this.vendorServiceList[0]?.id && this.awbDetailsForm.get('ddlVendorService').setValue(this.vendorServiceList[0]?.id);
        }
      } catch (error) {
        console.error(error);
      }
    }
  }

  getAllProducts() {
    try {
      this.productService.GetAll({ isactive: true }).subscribe((res) => {
        if (res && res.success) {
          this.productList = res.data;
        }
      })
    } catch (error) {

    }
  }

  onProductChange(productid: number) {
    this.selectedProduct = this.productList.find(x => x.id == productid);
    const selectedProduct = this.selectedProduct;
    const defaultCountryCode = this.appCoreService.GetUserData()?.metaInfo?.defaultcountry;

    // remove shipment value mandate
    selectedProduct?.shipmenttype === 'DOX' ? this.awbDetailsForm.get('txtShipmentValue').disable() : this.awbDetailsForm.get('txtShipmentValue').enable();
    // Filter destination
    if (selectedProduct?.producttype === 'Domestic') {
      // remove shipment value mandate
      // this.productFilteredCountryList = this.destinationCountryList.filter(item => item.isocode === defaultCountryCode);

      this.productFilteredCountryList = this.countryList.filter(item => item.isocode === defaultCountryCode);
      this.awbDetailsForm.get('txtShipmentValue').clearValidators();
      this.awbDetailsForm.get('txtShipmentValue').setValidators([AmountValidation]);

      // remove mobileno. from shipper consginee mandate
      this.awbDetailsForm.get('shipperlocationdetails.txtMobileNo').clearValidators();
      this.awbDetailsForm.get('shipperlocationdetails.txtMobileNo').setValidators([MobileNumberValidation]);
      this.awbDetailsForm.get('consigneelocationdetails.txtMobileNo').clearValidators();
      this.awbDetailsForm.get('consigneelocationdetails.txtMobileNo').setValidators([MobileNumberValidation]);

    } else if (selectedProduct.producttype === 'International') {
      if (selectedProduct?.shipmenttype === 'NDOX') {
        this.awbDetailsForm.get('txtShipmentValue').setValidators([Validators.required, AmountValidation]);

        this.awbDetailsForm.get('shipperlocationdetails.txtMobileNo').clearValidators();
        this.awbDetailsForm.get('shipperlocationdetails.txtMobileNo').setValidators([Validators.required, MobileNumberValidation]);
        this.awbDetailsForm.get('consigneelocationdetails.txtMobileNo').clearValidators();
        this.awbDetailsForm.get('consigneelocationdetails.txtMobileNo').setValidators([Validators.required, MobileNumberValidation]);
      } else {
        this.awbDetailsForm.get('txtShipmentValue').clearValidators();
        this.awbDetailsForm.get('txtShipmentValue').setValidators([AmountValidation]);

        this.awbDetailsForm.get('shipperlocationdetails.txtMobileNo').clearValidators();
        this.awbDetailsForm.get('shipperlocationdetails.txtMobileNo').setValidators([MobileNumberValidation]);
        this.awbDetailsForm.get('consigneelocationdetails.txtMobileNo').clearValidators();
        this.awbDetailsForm.get('consigneelocationdetails.txtMobileNo').setValidators([MobileNumberValidation]);
      }
      // this.productFilteredCountryList = this.destinationCountryList.filter(item => item.isocode !== defaultCountryCode);
      this.productFilteredCountryList = this.countryList.filter(item => item.isocode !== defaultCountryCode);
    } else {
      // this.productFilteredCountryList = this.destinationCountryList;
      this.productFilteredCountryList = this.countryList;
      this.awbDetailsForm.get('txtShipmentValue').clearValidators();
      this.awbDetailsForm.get('txtShipmentValue').setValidators([AmountValidation]);

      this.awbDetailsForm.get('shipperlocationdetails.txtMobileNo').clearValidators();
      this.awbDetailsForm.get('shipperlocationdetails.txtMobileNo').setValidators([MobileNumberValidation]);
      this.awbDetailsForm.get('consigneelocationdetails.txtMobileNo').clearValidators();
      this.awbDetailsForm.get('consigneelocationdetails.txtMobileNo').setValidators([MobileNumberValidation]);
    }
    this.awbDetailsForm.get('txtShipmentValue').updateValueAndValidity();

    this.awbDetailsForm.get('shipperlocationdetails.txtMobileNo').updateValueAndValidity();
    this.awbDetailsForm.get('consigneelocationdetails.txtMobileNo').updateValueAndValidity();

    let ConsigneeCountry = this.awbDetailsForm.get('consigneelocationdetails.ddlCountry').value;
    if (!this.productFilteredCountryList?.filter(x => x.isocode === ConsigneeCountry)?.length) {
      this.awbDetailsForm.get('consigneelocationdetails.ddlCountry').setValue(null);
    }

    // //bind company on product change
    // this.companyList = this.respCompanyList;
    // if (selectedProduct?.producttype) {
    //   this.companyList = this.companyList.filter(item => item.operationtype.includes(selectedProduct.producttype));
    // }

    this.checkVolumetricDetail();
    this.getCustomerApplicableTax();

    /*on product change call rate api*/
    this.getAWBCharges(RateCategory.CUSTOMER);
    this.CustomerVolumetricRequired();
  }

  getAWBCharges(category: RateCategory) {
    try {
      let searchtype = "Tariff";
      //let searchtype = "";

      const shipperlocationdetails = this.awbDetailsForm.get('shipperlocationdetails');
      // console.log('shipperlocationdetails', shipperlocationdetails);
      const consigneelocationdetails = this.awbDetailsForm.get('consigneelocationdetails');

      let selectedDestinationCountry = this.destinationCountryList.filter(x => x.isocode === consigneelocationdetails.get('ddlCountry').value);
      let selectedDestinationState = this.destinationStateList.filter(x => x.isocode === consigneelocationdetails.get('ddlState').value);
      let selectedDestinationCity = this.destinationCityList.filter(x => x.isocode === consigneelocationdetails.get('ddlCity').value);

      let selectedOriginCountry = this.originCountryList.filter(x => x.isocode === shipperlocationdetails.get('ddlCountry').value);
      let selectedOriginState = this.originStateList.filter(x => x.isocode === shipperlocationdetails.get('ddlState').value);
      let selectedOriginCity = this.originCityList.filter(x => x.isocode === shipperlocationdetails.get('ddlCity').value);

      let selectedVendor = null, selectedProduct = null, selectedService = null, applicable_weight = 0;
      let chargetype = this.awbDetailsForm.get('ddlChargeType').value;
      let selectedCustomer = this.awbDetailsForm.controls.ddlCustomer?.value || null;

      switch (category) {
        case RateCategory.CUSTOMER:
          selectedVendor = this.awbDetailsForm.get('ddlVendor').value ? this.vendorList.filter(x => x.id === this.awbDetailsForm.get('ddlVendor').value) : null;
          selectedProduct = this.productList.filter(x => x.id === this.awbDetailsForm.controls.ddlProduct?.value)[0]?.code;
          selectedService = this.vendorServiceList.filter(x => x.id === this.awbDetailsForm.controls.ddlService?.value)[0]?.servicename;

          let actual_weight = this.piecesForm.get("totalactualweight").value || 0;
          let volumetric_weight = this.piecesForm.get("totalvolumetricweight").value || 0;
          applicable_weight = actual_weight >= volumetric_weight ? actual_weight : volumetric_weight;
          searchtype = !selectedCustomer ? "Tariff" : RateCategory.CUSTOMER;
          break;
        case RateCategory.VENDOR:
          applicable_weight = 0;
          searchtype = RateCategory.VENDOR;
          break;
      }

      if (selectedVendor?.length && selectedProduct != null && selectedService != null && selectedDestinationCountry?.length && applicable_weight > 0) {
        const reqObj = {
          searchtype: searchtype,
          customer: this.awbDetailsForm.controls.ddlCustomer?.value || null,
          company: this.awbDetailsForm.controls.ddlCompanies?.value || null,
          vendor: selectedVendor,
          service: selectedService,
          product: selectedProduct,
          origincountry: selectedOriginCountry,
          originstate: selectedOriginState,
          origincity: selectedOriginCity,
          destinationcountry: selectedDestinationCountry,
          destinationstate: selectedDestinationState,
          destinationcity: selectedDestinationCity,
          weight: applicable_weight,
          bookingdate: this.awbDetailsForm.get('txtDateTime').value,
          is_oda: chargetype?.includes("ODA") || false,
          is_commercial: chargetype?.includes("Commercial") || false,
          is_medical: chargetype?.includes("Medical") || false,
          is_insurance: chargetype?.includes("Insurance") || false
          //actual_weight: this.rateCompareForm.controls.txtActualWeight.value,
          //volumetric_weight: this.rateCompareForm.controls.txtVolumetricWeight.value,
        }

        this.chargesService.GetApplicableCharges(reqObj).subscribe((res) => {
          if (res && res.success) {
            let awbCharges = res.data?.availableCharges || [];
            // console.log('category', category);
            //this.setCharges(awbCharges, category);
            this.addCharges(awbCharges, category);
            this.customerConfig.fuel = res.data?.fuel;
            this.customerConfig.tax = res.data?.tax;
            //console.log(res);
            // console.log('customerConfig', this.customerConfig);

          }
        });
      }
    } catch (error) {
      console.error(error);
    }
    // this.volumetricDetails();
  }

  addCharges(charges: any[], category: RateCategory) {
    // let othercharges = charges["othercharges"] || [];
    // let freightcharges = charges["freight"] || null;
    let customerCharges: any[] = [];

    let otherChargesMatch: any[] = charges;

    let idx = 0;
    if (otherChargesMatch?.length) {
      for (const c of otherChargesMatch) {
        let igst = c.tax?.filter(x => x.type === 'IGST')[0].value;
        let sgst = c.tax?.filter(x => x.type === 'SGST')[0].value;
        let cgst = c.tax?.filter(x => x.type === 'CGST')[0].value;
        let fuel_igst = c.fueltax?.filter(x => x.type === 'IGST')?.[0]?.value;
        let fuel_sgst = c.fueltax?.filter(x => x.type === 'SGST')?.[0]?.value;
        let fuel_cgst = c.fueltax?.filter(x => x.type === 'CGST')?.[0]?.value;

        if (c.chargename?.toLowerCase() === 'freight') {
          let item_total = (parseFloat(c.rate || 0) + parseFloat(c.fuelamount || 0) + (parseFloat(igst || 0) + Number(sgst || 0) + parseFloat(cgst || 0)) + parseFloat(c.taxonfuelamount || 0)) || 0;
          this.piecesForm.get('totalchargeableweight').setValue(Number(c.weight));

          let _obj = {
            id: 0,
            chargesid: this.chargeList?.filter(_x => _x.name?.toLowerCase() === c.chargename.toLowerCase())[0]?.id,
            chargesdescription: c.chargename,
            itemamount: c.rate || 0,
            isitemfuel: c.fuelapplicable || false,
            fuelamount: c.fuelamount || 0,
            fueltax: c.taxonfuelapplicable || false,
            fueltaxamount: c.taxonfuelamount || 0,
            igst: Number(igst) + Number(fuel_igst),
            sgst: sgst + fuel_sgst,
            cgst: cgst + fuel_cgst,
            tax: c.taxapplicable || false,
            taxamount: (igst + sgst + cgst),
            itemtotal: Number(item_total.toFixed(3)),
            system: true
          };

          let chargeType: any[] = c.chargetype || [];

          if (chargeType?.includes(ChargeType.AWB) && category === RateCategory.CUSTOMER) {
            this.customerRowData.push({ ..._obj, chargetype: "Customer" });
          }
          // else if (chargeType?.includes(ChargeType.PURCHASE) && category === RateCategory.VENDOR) {
          //   this.vendorRowData.push({ ..._obj, chargetype: "Vendor" });
          // }

        } else {

          let total_igst = (Number(igst) + Number(fuel_igst)) || 0;
          let obj = {
            id: (idx + 1),
            chargesid: this.chargeList?.filter(_x => _x.name === c.chargename)[0]?.id,
            chargesdescription: c.chargename,
            itemamount: c.otherchargeamount || 0,
            isitemfuel: c.fuelapplicable || false,
            fuelamount: c.fuelamount || 0,
            fueltax: c.taxonfuelapplicable || false,
            fueltaxamount: c.taxonfuelamount || 0,
            igst: Number(total_igst.toFixed(3)),
            sgst: sgst,
            cgst: cgst,
            tax: c.taxapplicable || false,
            taxamount: (igst + sgst + cgst),
            itemtotal: c.otherchargeamount + (igst + sgst + cgst) + c.fuelamount + c.taxonfuelamount,
            system: true
          };

          let chargeType: any[] = c.chargetype || [];

          if (chargeType?.includes(ChargeType.AWB) && category === RateCategory.CUSTOMER) {
            this.customerRowData.push({ ...obj, chargetype: "Customer" });
          }
          // else if (chargeType?.includes(ChargeType.PURCHASE) && category === RateCategory.VENDOR) {
          //   this.vendorRowData.push({ ...obj, chargetype: "Vendor" });
          // }
        }
      }
    }

    let chargesData = this.customerRowData;

    // console.log('chargesData 6 ', chargesData);

    this.getChargesSummary(chargesData, (data) => {
      this.addChargeData(data, category);
      // if (category == RateCategory.CUSTOMER)
      //   this.customerData = data;
      // else
      //   this.vendorData = data;
    });
  }

  addChargeData(data?: any[], category: string = '') {
    this.customerData = data;
    const totalAmount = Number(this.customerData?.totalamount) || 0;
    this.totalCustomerCharges = parseFloat(totalAmount.toFixed(3)) || 0;
  }

  getChargesSummary(chargesdetails: any[], cb: any) {
    let chargeOtherTotal = 0, chargeTotalFuel = 0, chargeTotalAmount = 0, contract_amount = 0, chargeSubTotal = 0, igstTotal = 0, cgstTotal = 0, sgstTotal = 0;
    for (const charge of chargesdetails) {
      chargeOtherTotal += charge?.chargesdescription?.toLowerCase() !== "freight" ? parseFloat(charge.itemamount) : 0;;
      chargeTotalFuel += parseFloat(charge.fuelamount);
      chargeTotalAmount += parseFloat(charge.itemtotal);
      contract_amount += charge?.chargesdescription?.toLowerCase() === "freight" ? charge.itemamount : 0;

      igstTotal += charge?.tax ? parseFloat(charge.igst || 0) : 0;
      sgstTotal += charge?.tax ? parseFloat(charge.sgst || 0) : 0;
      cgstTotal += charge?.tax ? parseFloat(charge.cgst || 0) : 0;
    }
    chargeSubTotal = chargeOtherTotal + contract_amount;
    const obj = {
      subtotal: chargeSubTotal,
      othercharges: chargeOtherTotal,
      contractcharges: contract_amount,
      totalfuel: chargeTotalFuel,
      totalamount: chargeTotalAmount,
      igst: igstTotal.toFixed(3),
      cgst: cgstTotal.toFixed(3),
      sgst: sgstTotal.toFixed(3)
    }
    cb(obj);
  }

  getCustomerApplicableTax() {
    try {
      let customer = this.awbDetailsForm.controls.ddlCustomer.value || null;
      let selectedProduct = this.productList.filter(x => x.id == this.awbDetailsForm.get('ddlProduct')?.value);

      let reqObj = {
        customer: customer || null,
        searchtype: !customer ? 'Tariff' : 'Customer',
        product: selectedProduct ? selectedProduct[0]?.code : null,
        bookingdate: this.utilities.FormatDateWithTime(0).dateString,
        company: this.awbDetailsForm.controls.ddlCompanies.value
      }

      this.rateUploadService.getCustomerTaxes(reqObj).subscribe((res) => {
        //if (res && res.success) {
        if (res) {
          //console.log('customerConfig',res);
          this.customerConfig.tax = {
            igst: Number(res.data?.[0]?.igst),
            cgst: Number(res.data?.[0]?.cgst),
            sgst: Number(res.data?.[0]?.sgst),
            igstapplicable: res.data?.[0]?.isIGSTApplicable || false
          }
        }
        // if (!res.data.length) {
        //   this.appCoreService.showMessage(res.message, '', 'info');
        // }
        //}
      });
    } catch (error) {
    }
  }

  CustomerVolumetricRequired() {
    //&& this.awbConfig.isCustomerLoginVolumetricRequiredOnNdox
    if (this.isAccessTypeCustomer && this.awbConfig.isVolumetricRequired) {
      if (!this.isDOXSelected) {
        this.containers.controls.map(container => {
          container.get('pieceslength').setValidators([Validators.required]);
          container.get('piecesbreadth').setValidators([Validators.required]);
          container.get('piecesheight').setValidators([Validators.required]);
          container.get('pieceslength').updateValueAndValidity();
          container.get('piecesbreadth').updateValueAndValidity();
          container.get('piecesheight').updateValueAndValidity();
        });
      }
      else {
        this.containers.controls.forEach(container => {
          container.get('pieceslength').clearValidators();
          container.get('piecesbreadth').clearValidators();
          container.get('piecesheight').clearValidators();
        });
      }
    }
  };

  loadDefaultsValues() {
    this.awbDetailsForm.get('txtAwbDate')?.setValue(this.utilities.formatDate().dateString);
    this.awbDetailsForm.get('txtPieces')?.setValue(null);
    this.awbDetailsForm.get('ddlPiecesUnit')?.setValue(this.unitList[0].value);
    this.piecesDetailsList = [];
    const newRow = {
      piecelength: null,
      piecebreadth: null,
      pieceheight: null,
      actualweight: null,
      volumetricweight: null,
      chargeweight: null,
    };
    this.piecesDetailsList.push(newRow);
    this.finalList = [];
    this.manifestFormSubmitted = false;
    this.awbDetailsFormSubmitted = false;
  }
  formatter = (x: { name: string }) => x.name;

  // -----------------------------------------------------------------------

  get containers(): FormArray {
    return this.piecesForm.get('containers') as FormArray;
  }

  newContainer(pCount): FormGroup {
    return this._fb.group({
      piecescounter: (this.containers.length + 1),
      piecescount: [pCount || '', Validators.compose([Validators.required, Validators.min(1)])],
      piecesactualweight: ['', Validators.compose([Validators.required, Validators.pattern(/^\d{0,9}(\.\d{0,3})?$/)])],
      pieceslength: '',
      piecesbreadth: '',
      piecesheight: '',
      piecesvolumetricweight: 0,
      pieceschargeableweight: [{ value: 0, disabled: true }],
      // subitems: this._fb.array([])
      containeritemsgroup: this._fb.group({
        containerid: '',
        editmode: false,
        editsubitemid: 0,
        description: [null, Validators.compose([Validators.maxLength(40), Validators.required])],
        hsncode: [null, Validators.compose([Validators.maxLength(10)])],
        unit: ['PCS'],
        weight: [null, Validators.compose([Validators.pattern(/^[0-9]{0,9}(\.[0-9]{0,3})?$/)])],
        quantity: [null, Validators.compose([Validators.pattern(/^\d{1,3}$/), Validators.required, nonZeroValidator])],
        rate: [null, Validators.compose([Validators.required, Validators.pattern(/^[0-9]{0,10}(\.[0-9]{0,3})?$/)])],
        amount: [{ value: '', disabled: true }],
        subitems: this._fb.array([])
      })
    });
  }

  addContainer(pCount) {
    this.containers.push(this.newContainer(pCount));
  }

  removeContainer(pCount) {
    this.containers.removeAt(pCount);
  }

  subItem(itemIndex: number): FormArray {
    return this.containers
      .at(itemIndex)
      .get('containeritemsgroup')
      .get('subitems') as FormArray;
  }

  newSubItem(item): FormGroup {
    // console.log(item);
    return this._fb.group({
      itemdescription: item?.description?.name ?? item?.description ?? item?.itemdescription,
      itemhsncode: item.hsncode || item.itemhsncode,
      itemunit: item.unit || item.itemunit,
      itemweight: item.weight || item.itemweight,
      itemquantity: item.quantity || item.itemquantity,
      itemrate: item.rate || item.itemrate,
      itemamount: item.amount || item.itemamount
    });
  }

  addSubItem(itemIndex: number, containerGroup: FormGroup) {
    // this.subItem(itemIndex).push(this.newSubItem(item));
    let item = containerGroup.value;
    // temp fix - disabled amount value read
    item.amount = containerGroup.get('amount').value;
    containerGroup.markAllAsTouched();
    if (containerGroup.valid) {
      // containerGroup.reset();
      containerGroup.patchValue({
        description: '',
        hsncode: '',
        weight: '',
        unit: 'PCS',
        quantity: '',
        rate: '',
        amount: 0
      });
      containerGroup.markAsUntouched();
      containerGroup.updateValueAndValidity();
      this.subItem(itemIndex).insert(0, this.newSubItem(item));
      this.focusNextContainer(itemIndex + 1);
      this.calculateShipmentValue();
    }
  }

  calculateShipmentValue() {
    this.totalShipment = 0;
    const txtShipmentValue = this.awbDetailsForm.get('txtShipmentValue');

    if (this.containers?.controls?.length) {
      this.containers.controls.forEach((item: any) => {
        const subItems = item?.controls?.containeritemsgroup?.value?.subitems ?? [];

        const hasPositiveAmount = subItems.some(s => s?.itemamount > 0);
        const isDOX = this.selectedProduct?.shipmenttype === 'DOX';
        const isInternational = this.selectedProduct?.producttype === 'International';

        if (hasPositiveAmount) {
          txtShipmentValue?.disable();
          txtShipmentValue?.clearValidators();
        } else {
          isDOX ? txtShipmentValue?.disable() : txtShipmentValue?.enable();
          txtShipmentValue?.clearValidators();
          txtShipmentValue?.setValidators(isInternational ? [AmountValidation, Validators.required] : [AmountValidation]);
        }

        txtShipmentValue?.updateValueAndValidity();

        subItems.forEach(s => this.totalShipment += Number(s?.itemamount) || 0);
      });
    }

    txtShipmentValue?.setValue(this.totalShipment > 0 ? this.totalShipment : null);
  }

  editSubItem(containerGroup: FormGroup, subItem, itemIdx) {
    // this.subItem(itemIndex).push(this.newSubItem(item));
    // console.log(subItem);
    containerGroup.patchValue({
      editmode: true,
      editsubitemid: itemIdx,
      description: { name: subItem.value.itemdescription, hsncode: 234 },
      hsncode: subItem.value.itemhsncode,
      weight: subItem.value.itemweight,
      unit: subItem.value.itemunit,
      quantity: subItem.value.itemquantity,
      rate: subItem.value.itemrate,
      amount: subItem.value.itemamount
    });
    // Disable the description control
    containerGroup.get('description')?.disable();
  }

  cancelUpdateSubItem(containerGroup: FormGroup) {
    containerGroup.patchValue({
      editmode: false,
      description: '',
      hsncode: '',
      weight: '',
      unit: 'PCS',
      quantity: '',
      rate: '',
      amount: 0
    });
    // Enable the description control
    containerGroup.get('description')?.enable();
    containerGroup.markAsUntouched();
    containerGroup.updateValueAndValidity();
  }

  updateSubItem(containerGroup: FormGroup) {
    let item = containerGroup.value;
    // console.log('item', item);
    // console.log('item', containerGroup.getRawValue());
    // temp fix - disabled amount value read
    item.amount = containerGroup.get('amount').value;
    item.description = containerGroup.get('description').value;
    containerGroup.markAllAsTouched();
    if (containerGroup.invalid) return;
    if (containerGroup.valid) {
      // containerGroup.reset();
      containerGroup.patchValue({
        description: '',
        hsncode: '',
        weight: '',
        unit: 'PCS',
        quantity: '',
        rate: '',
        amount: 0
      });
      containerGroup.markAsUntouched();
      containerGroup.updateValueAndValidity();
      // console.log(containerGroup.get('subitems'));
      (containerGroup.get('subitems') as FormArray).at(item.editsubitemid).patchValue({
        itemdescription: item?.description?.name ?? item?.description,
        itemhsncode: item.hsncode,
        itemweight: item.weight,
        itemunit: item.unit,
        itemquantity: item.quantity,
        itemrate: item.rate,
        itemamount: item.amount
      });
      // Enable the description control
      containerGroup.get('description')?.enable();
      this.calculateShipmentValue();
    }

    containerGroup.patchValue({
      editmode: false,
      description: '',
      hsncode: '',
      weight: '',
      unit: 'PCS',
      quantity: '',
      rate: '',
      amount: 0
    });
    containerGroup.markAsUntouched();
    containerGroup.updateValueAndValidity();
  }

  async removeSubItem(itemIndex: number, currentIdx: number) {
    const confiremed = await this.openConfirmationDialog('Are you sure you want to delete ?');
    if (confiremed) {
      this.subItem(itemIndex).removeAt(currentIdx);
      this.calculateShipmentValue();
    }
  }

  addNewContainerCustom(index?: number) {
    if (index >= 0) {
      const totalLength = this.containers?.controls?.length - 1;
      if (totalLength !== index) {
        return;
      }
    }
    let piecesCount = 1, allowAdd = false;
    // console.log(this.containers);
    // this.piecesForm.markAllAsTouched();
    this.containers.controls.forEach((val, idx) => {
      // console.log('val', val, 'idx', idx);
      val.get('piecescount').markAsTouched();
      val.get('piecesactualweight').markAsTouched();
      // val.get('containeritemsgroup').markAsUntouched({onlySelf: true});
      // val.get('containeritemsgroup').clearValidators();
      // val.get('containeritemsgroup').setErrors(null);
      // val.get('containeritemsgroup').updateValueAndValidity();
      val.get('containeritemsgroup').disable();
    })

    allowAdd = this.containers.valid;
    if (allowAdd) {
      this.addContainer(piecesCount);
      this.containers.controls.forEach((val) => {
        val.get('containeritemsgroup')?.enable();
        val.get('containeritemsgroup.amount')?.disable();
      });
      this.calculateWeightNew();
      // focus on the last container' actual weight
      this.focusFirstActualWeight();
    }
  };

  async removeContainerCustom(idx) {
    let allowDelete = false;
    // console.log('container validity', this.containers.valid);
    // console.log(this.containers);
    allowDelete = (this.containers.controls.length > 1);
    this.piecesForm.markAllAsTouched();
    if (allowDelete) {
      const confiremed = await this.openConfirmationDialog('Are you sure you want to delete ?');
      if (confiremed) {
        this.removeContainer(idx);
        this.calculateWeightNew();
      }
    } else {
      // this.appCoreService.showMessage('Minimum of 1 piece is required', '', 'warning');
      this.openWarningDialog("Cannot Delete!. Minimum of 1 piece is required");
    }
  };

  async openWarningDialog(msg: any) {
    const isHtml = msg?.includes('<') && msg?.includes('>') || false
    Swal.fire({
      // title: 'Oops!',
      text: msg,
      icon: 'warning',
      confirmButtonText: 'OK',
      allowEscapeKey: false,
      allowOutsideClick: false
    })
  }

  calculateItemAmount(currentContainer: FormGroup) {
    let quantity = currentContainer.get('containeritemsgroup').get('quantity').value || 0;
    let rate = currentContainer.get('containeritemsgroup').get('rate').value || 0;
    const amount = quantity * rate;
    currentContainer.get('containeritemsgroup').patchValue({
      amount: amount
    });

  }

  bindDefaultPiecesContainer() {
    let piecesCount = 1;
    this.piecesForm.get('totalpieces').setValue(piecesCount);
    this.addContainer(piecesCount);
  }
  itemDescriptionList: any[] = [];

  bindItemDescriptions() {
    try {
      this.miscService.GetAllGoods().subscribe((res) => {
        if (res && res.success) {
          this.itemDescriptionList = res.data;
        }
      })
    } catch (e) {
      console.error(e);
    }
  }

  formatterItemDescription = (x: { name: string }) => x.name;

  searchItemDescription: OperatorFunction<string, readonly { name; flag }[]> = (text$: Observable<string>) =>
    text$.pipe(
      debounceTime(200),
      distinctUntilChanged(),
      map((term) =>
        term === ''
          ? []
          : this.itemDescriptionList?.filter((v) => v.name.toLowerCase().indexOf(term.toLowerCase()) > -1).slice(0, 10),
      ),
    );

  selectedItemDescriptionEvent(currentContainer: FormGroup, event: any) {
    try {
      if (event) {
        const item = event.item;
        currentContainer.get('containeritemsgroup').patchValue({
          hsncode: item.hsncode
        })
        this.focusItemWeightRef();
      }
    } catch (e) {
      console.error(e);
    }
  }

  productVolumetric() {
    const selectedProduct: any = this.productList.find((x: any) => x.id === this.awbDetailsForm.get('ddlProduct').value);
    const isInches = this.awbDetailsForm.get('ddlPiecesUnit')?.value === 'Inches';
    if (isInches) {
      this.awbDetailsForm.get('txtDivision').setValue(selectedProduct?.volumetricdivisor?.inches);
    }
    else {
      this.awbDetailsForm.get('txtDivision').setValue(selectedProduct?.volumetricdivisor?.centimeter);
    }
  }

  volumetricDetails(piecesfldDet?, isBulk: boolean = false) {
    if (isBulk) {
      piecesfldDet = this.piecesDetailsList[0];
      piecesfldDet?.controls?.length > 0 && piecesfldDet?.controls?.piecesvolumetricweight?.reset();
    }
    let totalVolumetricWeight = 0;
    const selectedCustomer = this.customerList.find(x => x.id === this.awbDetailsForm.get('ddlCustomer').value);
    const selectedProduct = this.productList.find(x => x.id === this.awbDetailsForm.get('ddlProduct').value);
    let division = 0;
    let cftValue: number = 1;
    if (this.volumetricList.length > 0) {
      const isInches = this.awbDetailsForm.get('ddlMeasurementUnit')?.value === 'Inches';
      division = (isInches ? this.volumetricList[0].inches : this.volumetricList[0].centimeter);
      cftValue = this.volumetricList[0].cft;
    } else {
      const isInches = this.awbDetailsForm.get('ddlMeasurementUnit')?.value === 'Inches';
      division = (isInches ? selectedProduct?.volumetricdivisor?.inches : selectedProduct?.volumetricdivisor?.centimeter) ?? (isInches ? MeasurementUnit.INCHES : MeasurementUnit.CENTIMETER);

    }

    if (!division) {
      this.openWarningDialog('Please select product');
      return;
    }

    if (selectedCustomer && selectedCustomer.cftvalue != null && selectedCustomer.cftvalue != undefined) {
      cftValue = Number(selectedCustomer.cftvalue);
    }
    this.awbDetailsForm.get('txtDivision').setValue(division);
    if (!piecesfldDet && !isBulk) {
      piecesfldDet = this.piecesDetailsList[0];
    }
    if (isBulk) {
      for (const container of this.containers.controls) {
        let pieceCount = container.get('piecescount').value || 0;
        let pieceslength = container.get('pieceslength').value || 0;
        let piecesbreadth = container.get('piecesbreadth').value || 0;
        let piecesheight = container.get('piecesheight').value || 0;
        const volumetric = (pieceslength * piecesbreadth * piecesheight * cftValue) / division;
        if (volumetric) {
          container.get('piecesvolumetricweight')?.setValue((parseFloat((pieceCount * volumetric).toString())).toFixed(3));
        }
      }
    }
    else {
      const pieceCount = parseFloat(piecesfldDet?.value?.piecescount || 0);
      const lengthValue = parseFloat(piecesfldDet?.value?.pieceslength || 0);
      const breadthValue = parseFloat(piecesfldDet?.value?.piecesbreadth || 0);
      const heightValue = parseFloat(piecesfldDet?.value?.piecesheight || 0);
      const volumetric = (lengthValue * breadthValue * heightValue * cftValue) / division;
      if (volumetric) {
        piecesfldDet.value.piecesvolumetricweight = parseFloat(volumetric > 0 ? (pieceCount * volumetric).toFixed(3) : piecesfldDet.volumetricweight > 0 ? piecesfldDet.volumetricweight : 0);
        piecesfldDet.controls.piecesvolumetricweight.setValue(piecesfldDet.value.piecesvolumetricweight);
      }
    }
    this.calculateWeightNew();
  }

  calculateWeight() {
    let totalPieces = 0, totalActualWeight = 0, totalVolumetricWeight = 0, totalChargeableWeight = 0;
    for (const container of this.containers.controls) {
      // console.log('container', container);
      let pieceCount = container.get('piecescount').value || 0;
      let piecesactualweight = container.get('piecesactualweight').value || 0;
      let piecesvolumetricweight = container.get('piecesvolumetricweight').value || 0;
      let pieceschargeableweight = container.get('pieceschargeableweight').value || 0;
      let pieceslength = container.get('pieceslength').value || 0;
      let piecesbreadth = container.get('piecesbreadth').value || 0;
      let piecesheight = container.get('piecesheight').value || 0;
      if ((pieceslength * piecesbreadth * piecesheight) > 0) {
        container.get('piecesvolumetricweight').disable();
      }
      container.get('pieceschargeableweight').setValue((Math.max(pieceCount * piecesactualweight, piecesvolumetricweight)).toFixed(3));
      // console.log(pieceCount, piecesactualweight);
      totalPieces += pieceCount;
      totalActualWeight += parseFloat((pieceCount * piecesactualweight).toString());
      totalVolumetricWeight += parseFloat(piecesvolumetricweight);


    }
    // console.log('totalActualWeight', totalActualWeight);

    this.piecesForm.get('totalpieces').setValue(totalPieces || 0);
    this.piecesForm.get('totalactualweight').setValue(totalActualWeight.toFixed(3) || 0);
    this.piecesForm.get('totalvolumetricweight').setValue(totalVolumetricWeight.toFixed(3) || 0);

    this.piecesForm.get('totalchargeableweight').setValue(Math.max(+ totalActualWeight.toFixed(3), + totalVolumetricWeight.toFixed(3)) || 0);

  }

  totalPiecesValidate(event: KeyboardEvent): void {
    const val = (event.target as HTMLInputElement).value;
    if (event.keyCode !== 8 && event.keyCode !== 46 && val?.length >= 3 && event.keyCode !== 9) {
      event.preventDefault();
    }
    if (event.keyCode == 69 || event.keyCode == 107 || event.keyCode == 190) {
      event.preventDefault();
    }
  }

  toggleRowExpansion(index: number): void {
    this.expandedRows[index] = !this.expandedRows[index];
    if (this.expandedRows[index]) {
      this.containers.at(index).get('containeritemsgroup').enable();
    } else {
      this.containers.at(index).get('containeritemsgroup').disable();
    }
  }

  isRowExpanded(index: number): boolean {
    return this.expandedRows[index];
  }

  piecesValidate(event: KeyboardEvent): void {
    const val = (event.target as HTMLInputElement).value;
    if (event.keyCode !== 8 && event.keyCode !== 46 && val?.length >= 10 && event.keyCode !== 9) {
      event.preventDefault();
    }
    if (event.keyCode == 69 || event.keyCode == 107) {
      event.preventDefault();
    }
  }

  onKeyDown(event: KeyboardEvent) {
    if (event.keyCode == 69 || event.keyCode == 107) {
      event.preventDefault();
    }
  }
  async warningDialog(msg: any) {
    const isHtml = msg.includes('<') && msg.includes('>');
    // const confirmText = isHtml ? '<i class="bx bx-download"></li> Download' : null;
    const res = await Swal.fire({
      title: 'Warning!',
      [isHtml ? 'html' : 'text']: msg,
      icon: 'warning',
      showCloseButton: true,
      allowEscapeKey: false,
      allowOutsideClick: false
    });
  }

  focusFirstInvalidField(formGroup: FormGroup) {
    setTimeout(() => {
      if (!formGroup) return;

      // Find the first form control that is invalid
      const firstInvalidControl = document.querySelector('.ng-invalid');
      // block start find the first invalid field to focus it
      if (firstInvalidControl) {
        firstInvalidControl.scrollIntoView({ behavior: 'smooth', block: 'start' });
        (firstInvalidControl as HTMLElement).focus();
      }
    });
  };

  async addAwb() {
    this.isFormSubmitted = true;
    this.awbDetailsFormSubmitted = true;
    const awbDetailsForm = this.awbDetailsForm;
    // const isCreditAvilable = await this.checkAndBindAvailableCredit();
    //if (!isCreditAvilable) return this.openErrorDialog('No credit balance available.');
    let invalidContainers = [];
    const invalidIndexes: number[] = [];
    this.containers.controls.forEach((container, i) => {
      if (!container.get('piecesactualweight').valid) {
        invalidContainers.push(`Weight or volumetric info missing at container ${i + 1}`);
        invalidIndexes.push(i);  // Store the invalid index
      }
    });

    //console.log(invalidContainers);
    if (invalidContainers.length) {
      await this.openWarningDialog(invalidContainers.join(','));
      if (invalidIndexes.length) {
        setTimeout(() => {
          const invalidField = this.piecesActualWeightInputs?.toArray().find(field =>
            field.nativeElement.classList.contains('ng-invalid')
          );

          if (invalidField) {
            invalidField.nativeElement.focus();
          }
        }, 300);
      }
      return;
    }

    if (this.serviceConfig.proforma.detailsmandatory) {
      let list: any[] = [];
      let invalidIndexes: number[] = [];
      const pieces = this.piecesForm.get('containers').value;

      for (let i = 0; i < pieces.length; i++) {
        const subitem = this.subItem(i);
        if (!subitem.length) {
          list.push(`Piece No ${i + 1}`);
          invalidIndexes.push(i);
        }
      }

      if (list.length) {
        let msg = `<span><label>Please provide at least one Item Detail for the following Pieces:</label><br><label>${list.join(', ')}</label></span>`;
        await this.warningDialog(msg);

        if (invalidIndexes.length) {
          // Expand first invalid row
          this.toggleRowExpansion(invalidIndexes[0]);
          setTimeout(() => {
            // Find and focus on the first available input
            const descriptionInput = this.descriptionRefs.first;
            if (descriptionInput) {
              descriptionInput.nativeElement.focus();
            }
          }, 300);
        }
        return;
      }
    }

    const totalActualWeight = this.piecesForm.get('totalactualweight')?.value;;
    const isNotWeightValid = this.validateActualWeight(totalActualWeight)
    if (isNotWeightValid) {
      return this.warningDialog(isNotWeightValid);
    }
    //// Check if the control is invalid
    // Object.keys(this.awbDetailsForm.controls).forEach(key => {
    //   const control = this.awbDetailsForm.controls[key];`
    //   if (control.invalid) {
    //     // console.log(`${ key } control is invalid`);
    //   }
    // });

    if (awbDetailsForm.invalid) {
      // Get the list of invalid controls
      this.focusFirstInvalidField(this.awbDetailsForm);
      const invalidControls = Object.keys(awbDetailsForm.controls).filter(controlName => awbDetailsForm.controls[controlName].invalid);
      // console.log('Invalid controls:', invalidControls);
      return;
    }

    if (awbDetailsForm.valid) {

      if (Number(this.piecesForm.get('totalactualweight').value) === 0) {
        this.focusFirstActualWeight();
        return this.openWarningDialog('Actual weight cannot be 0 or empty.');
      }

      let details = [];
      // let chargeForm = this.chargeForm;
      let shipperlocation = awbDetailsForm.get('shipperlocationdetails');
      let consigneelocation = awbDetailsForm.get('consigneelocationdetails');
      this.piecesForm.get('measurementunit').setValue(awbDetailsForm.get('ddlMeasurementUnit')?.value);

      let shipper = shipperlocation.get('txtName').value;
      shipper = (typeof shipper === 'string') ? shipper : shipper?.name;

      let consignee = consigneelocation.get('txtName').value;
      consignee = (typeof consignee === 'string') ? consignee : consignee?.name;

      this.insertIntoFinalList();

      const shipperNameValue: any = this.awbDetailsForm.get('shipperlocationdetails.txtName')?.value;
      let shipperName = shipperNameValue ? (typeof shipperNameValue === 'string' ? shipperNameValue?.toUpperCase()?.trim() : shipperNameValue?.name?.toUpperCase()) : null;
      let shipperArea = shipperlocation.get('txtArea').value;
      shipperArea = shipperArea ? (typeof shipperArea === 'string' ? shipperArea : shipperArea?.area) : null;
      let shipperPincode = shipperlocation.get('txtPincode')?.value;
      shipperPincode = shipperPincode ? (typeof shipperPincode === 'string' ? shipperPincode : shipperPincode?.pincode) : null;

      const consigneeNameValue: any = this.awbDetailsForm.get('consigneelocationdetails.txtName')?.value;
      let consigneeName = shipperNameValue ? (typeof consigneeNameValue === 'string' ? consigneeNameValue?.toUpperCase()?.trim() : consigneeNameValue?.name?.toUpperCase()) : null;
      let consigneeArea = consigneelocation.get('txtArea').value;
      consigneeArea = consigneeArea ? (typeof consigneeArea === 'string' ? consigneeArea : consigneeArea?.area) : null;
      let consigneePincode = consigneelocation.get('txtPincode')?.value;
      consigneePincode = consigneePincode ? (typeof consigneePincode === 'string' ? consigneePincode : consigneePincode?.pincode) : null;

      // get address book details
      details.push({
        info: {
          name: shipperName,
          type: 'Shipper',
          contactperson: shipperlocation.get('txtContactPerson')?.value?.trim()?.toUpperCase(),
          emailid: shipperlocation.get('txtEmail')?.value?.trim()?.toUpperCase(),
          location: {
            country: shipperlocation.get('ddlCountry')?.value,
            countrycode: this.originCountryList.find(x => x.isocode === shipperlocation.get('ddlCountry')?.value)?.code,
            state: shipperlocation.get('ddlState')?.value,
            statecode: this.originStateList.find(x => x.isocode === shipperlocation.get('ddlState')?.value)?.code,
            city: shipperlocation.get('ddlCity')?.value,
            citycode: this.originCityList.find(x => x.isocode === shipperlocation.get('ddlCity')?.value)?.code,
            pincode: shipperPincode,
            address1: shipperlocation.get('txtAddress1')?.value?.trim()?.toUpperCase(),
            address2: shipperlocation.get('txtAddress2')?.value?.trim()?.toUpperCase(),
            mobileno: shipperlocation.get('txtMobileNo')?.value,
            tel: shipperlocation.get('txtTelephoneNo')?.value,
            area: shipperArea?.trim()?.toUpperCase()
          },
          generatedby: this.appCoreService.GetUserData().accessType,
          generatedfromid: this.appCoreService.GetUserData().selectedServiceCenter,
          customerid: this.appCoreService.GetUserData().metaInfo.customerid
        },
      });

      details.push({
        info: {
          type: 'Consignee',
          name: consigneeName,
          contactperson: consigneelocation.get('txtContactPerson')?.value?.trim()?.toUpperCase(),
          emailid: consigneelocation.get('txtEmail')?.value?.trim()?.toUpperCase(),
          location: {
            country: consigneelocation.get('ddlCountry')?.value,
            countrycode: this.destinationCountryList.find(x => x.isocode === consigneelocation.get('ddlCountry')?.value)?.code,
            state: consigneelocation.get('ddlState')?.value,
            statecode: this.destinationStateList.find(x => x.isocode === consigneelocation.get('ddlState')?.value)?.code,
            city: consigneelocation.get('ddlCity')?.value,
            citycode: this.destinationCityList.find(x => x.isocode === consigneelocation.get('ddlCity')?.value)?.code,
            pincode: consigneePincode,
            address1: consigneelocation.get('txtAddress1')?.value?.trim()?.toUpperCase(),
            address2: consigneelocation.get('txtAddress2')?.value?.trim()?.toUpperCase(),
            mobileno: consigneelocation.get('txtMobileNo')?.value,
            tel: consigneelocation.get('txtTelephoneNo')?.value,
            area: consigneeArea ? consigneeArea?.trim()?.toUpperCase() : null
          },
          generatedby: this.appCoreService.GetUserData().accessType,
          generatedfromid: this.appCoreService.GetUserData().selectedServiceCenter,
          customerid: this.appCoreService.GetUserData().metaInfo.customerid
        },
      });

      if (Number(this.customerData?.igst) && (Number(this.customerData?.sgst) || Number(this.customerData?.sgst))) {
        this.openWarningDialog(`Entry cannot contains [IGST] or [CGST/SGST] at a time.`);
        return;
      }

      const shipperlocationdetails = this.awbDetailsForm.get('shipperlocationdetails');
      const consigneelocationdetails = this.awbDetailsForm.get('consigneelocationdetails');

      const reqObj = {
        mode: 'awb',
        generatedfromid: this.selectedSCId,
        awbnumber: awbDetailsForm.get('txtAwbNo')?.value,
        customerid: awbDetailsForm.get('ddlCustomer')?.value,
        companyid: awbDetailsForm.get('ddlCompanies')?.value,
        referenceno: awbDetailsForm.get('txtReferenceNo')?.value,
        frompickup: awbDetailsForm.get('usedPickup')?.value,
        bookingdate: awbDetailsForm.get('txtDateTime')?.value,
        productid: awbDetailsForm.get('ddlProduct')?.value,
        vendorid: awbDetailsForm.get('ddlVendor')?.value,
        serviceid: awbDetailsForm.get('ddlService')?.value,
        shipmentvalue: awbDetailsForm.get('txtShipmentValue')?.value,
        currencycode: awbDetailsForm.get('ddlCurrency')?.value,

        chargetypes: awbDetailsForm.get('ddlChargeType')?.value,
        paymenttype: awbDetailsForm.get('ddlPaymentType')?.value,

        details: details,
        pieces: this.piecesForm.getRawValue(),
        piecesupdates: this.piecesForm.dirty,

        productcode: this.productList.find(x => x.id === awbDetailsForm.get('ddlProduct')?.value).code,
        vendorcode: this.vendorList.find(x => x.id === awbDetailsForm.get('ddlVendor')?.value).code,

        origincountrycode: this.originCountryList.filter(x => x.isocode === shipperlocationdetails.get('ddlCountry').value)[0]?.code,
        originstatecode: this.originStateList.filter(x => x.isocode === shipperlocationdetails.get('ddlState').value)[0]?.code,
        origincitycode: this.originCityList.filter(x => x.isocode === shipperlocationdetails.get('ddlCity').value)[0]?.code,
        originpincode: shipperPincode || null,

        destinationcontrycode: this.destinationCountryList.filter(x => x.isocode === consigneelocationdetails.get('ddlCountry').value)[0]?.code,
        destinationstatecode: this.destinationStateList.filter(x => x.isocode === consigneelocationdetails.get('ddlState').value)[0]?.code,
        destinationcitycode: this.destinationCityList.filter(x => x.isocode === consigneelocationdetails.get('ddlCity').value)[0]?.code,
        consigneepincode: consigneePincode || null,
      };

      let requestObject = {
        generatedfromid: this.selectedSCId,
        awbnumber: awbDetailsForm.get('txtAwbNo')?.value,
        customerid: awbDetailsForm.get('ddlCustomer')?.value,
        companyid: awbDetailsForm.get('ddlCompanies')?.value,
        referenceno: awbDetailsForm.get('txtReferenceNo')?.value,
        frompickup: awbDetailsForm.get('usedPickup')?.value,
        bookingdate: awbDetailsForm.get('txtDateTime')?.value,
        productid: awbDetailsForm.get('ddlProduct')?.value,
        productcode: this.productList.find(x => x.id === awbDetailsForm.get('ddlProduct')?.value).code,
        vendorid: awbDetailsForm.get('ddlVendor')?.value,
        vendorcode: this.vendorList.find(x => x.id === awbDetailsForm.get('ddlVendor')?.value).code,
        serviceid: awbDetailsForm.get('ddlService')?.value,
        shipmentvalue: awbDetailsForm.get('txtShipmentValue')?.value,
        currencycode: awbDetailsForm.get('ddlCurrency')?.value,

        chargetypes: awbDetailsForm.get('ddlChargeType')?.value,
        paymenttype: awbDetailsForm.get('ddlPaymentType')?.value,
      };

      let awbRequestObject = {
        mode: 'awb',
        details: details,
      };

      let piecesRequestObject = {
        mode: 'pieces',
        id: null,
        pieces: this.piecesForm.getRawValue(),
        piecesupdates: this.piecesForm.dirty,
      };

      let chargesRequestObject = {
        mode: 'charges',
        id: null,
        charges: {
          updates: true,
          chargetype: this.customerRowData[0]?.chargetype || 'Customer',
          contractchargesamount: this.customerData?.contractcharges,
          otherchargesamount: this.customerData?.othercharges,
          subtotal: this.customerData?.subtotal,
          totalfuel: this.customerData?.totalfuel,
          taxes: {
            type: 'gst',
            tax: {
              igst: this.customerData?.igst,
              cgst: this.customerData?.cgst,
              sgst: this.customerData?.sgst,
            }
          },
          totalamount: this.customerData?.totalamount,
          chargesdetails: this.customerRowData,
        },
      };
      // console.log('requestObject', requestObject);
      // console.log('awbRequestObject', awbRequestObject);

      //check credit limit
      // console.log("req", reqObj);
      if (this.isCreditControlChecked) {
        const isCreditLimitRemain = await this.checkCreditLimit(reqObj);
        if (!isCreditLimitRemain) return this.ngxLoaderService.stop();
      };
      if (this.permConfig.isAddAllowed && awbDetailsForm.valid) {
        this.ngxLoaderService.start();
        // console.log("reqobj : ", reqObj.details);
        this.awbService.AddAWB({ ...requestObject, ...awbRequestObject }).subscribe(async (res) => {
          if (res && res.success) {
            // this.ngxLoaderService.stop();
            // console.log(res);

            let awbNumber = res?.data[0].awbnumber;
            await this.AddVendorAPI(awbNumber);
            let awbId = res?.data[0].id;
            // update request objects
            requestObject.awbnumber = awbNumber;
            piecesRequestObject.id = awbId;
            chargesRequestObject.id = awbId;

            if (res?.data?.apiResponse?.error) {
              // errorMsg = res?.data?.apiResponse.message;
            }

            if (awbNumber) {
              forkJoin({
                awbpieces: this.awbService.AddAWB({ ...requestObject, ...piecesRequestObject }).pipe(catchError(() => of(null))),
                awbcharges: this.awbService.AddAWB({ ...requestObject, ...chargesRequestObject }).pipe(catchError(() => of(null)))
              }).subscribe(async res => {
                this.ngxLoaderService.stop();
                const allSuccessful = Object.values(res).every(val => val !== null);
                if (allSuccessful) {
                  await this.proceedWithAwbInscan(awbNumber);
                  this.appCoreService.showMessage('AWB Created and Added to List.', '', 'success');
                  this.containers.clear(); // Ensure all form controls are removed
                  this.awbDetailsFormSubmitted = false;
                  this.bindDefaultPiecesContainer(); // Rebind the default values

                } else {
                  this.appCoreService.showMessage('Some Error Occured. Please Try again.', '', 'error');
                }
              });
            }

          }
          if (res && !res.success) {
            this.ngxLoaderService.stop();
            this.openWarningDialog(res.message);
          }
        });
      }
    }
  }

  async proceedWithAwbInscan(awbNumber: string) {
    if (awbNumber) {
      this.ngxLoaderService.start();
      try {
        const res = await lastValueFrom(this.awbService.AwbInscan({ awbnumber: awbNumber, generatedfromid: this.selectedSCId }));
        if (res && res.success) {
          await this.getAllAvailableAwb();
          this.ngxLoaderService.stop();
          this.resetawbDetailsForm();
          this.showAWBDetailsForm = false;
          this.isFormSubmitted = false;
          this.manifestForm.get('chkCreateAwb').setValue(false);
          //add awb number to list 
          const isParentAWB = this.awbNoList.some(awb => awb.parentawbnumber == awbNumber);
          if (isParentAWB) {
            this.selectedAWBList = [...this.selectedAWBList, ...this.awbNoList.filter(awb => awb.awbnumber.startsWith(awbNumber) && awb.awbnumber !== awbNumber)];
          } else {
            this.selectedAWBList = [...this.selectedAWBList, ...this.awbNoList.filter(awb => awb.awbnumber === awbNumber)];
          }
        }
      } catch (error) {
        this.ngxLoaderService.stop();
      }
    }
  }

  async AddVendorAPI(awbnumber: any) {
    // console.log('AddVendorAPI')
    let awbRequestObject = {
      mode: 'shipmentapi',
      awbnumber: awbnumber
    };

    this.awbService.AddAWB(awbRequestObject).subscribe(async (res) => {
      if (res && res.success) {
        let errorMsg: string = '', msg: string = '';
        if (res?.data?.[0]?.apiResponse) {
          errorMsg = res.data?.[0].apiResponse.message;
          res.data?.apiResponse?.message && this.openWarningDialog(res.data?.apiResponse?.message);
        }
      }
    });
    // console.log(awbRequestObject);
  }

  resetawbDetailsForm() {
    // Resetting the forms
    this.awbDetailsForm.reset();
    this.piecesForm.reset();

    // Set initial values and validators after reset
    this.awbDetailsFormSubmitted = false;

    // Set values for awbDetailsForm
    this.awbDetailsForm.patchValue({
      txtBookingDate: this.utilities.formatDate().dateTimeString,
      txtDivision: '5000',
      ddlPiecesUnit: this.unitList[0].value,
      ddlPaymentType: this.paymentTypeList[0]
    });

    // Reapply validators for awbDetailsForm
    this.awbDetailsForm.get('ddlCompanies')?.setValidators([Validators.required]);
    this.awbDetailsForm.get('ddlProduct')?.setValidators([Validators.required]);
    this.awbDetailsForm.get('ddlVendor')?.setValidators([Validators.required]);
    this.awbDetailsForm.get('ddlVendorService')?.setValidators([Validators.required]);

    // Re-enable disabled controls if needed
    this.awbDetailsForm.get('txtDivision')?.disable();

    // Set values for piecesForm
    this.piecesForm.patchValue({
      actualweightunit: 'KGS',
      totalpieces: 0,
      totalactualweight: '0.000',
      totalvolumetricweight: '0.000',
      totalchargeableweight: '0.000'
    });

    // Reapply validators for piecesForm
    this.piecesForm.get('totalactualweight')?.setValidators([
      Validators.required,
      Validators.pattern(/^\d{0,9}(\.\d{0,3})?$/)
    ]);
    this.piecesForm.get('totalvolumetricweight')?.setValidators([
      Validators.required,
      Validators.pattern(/^\d{0,9}(\.\d{0,3})?$/)
    ]);
    this.piecesForm.get('totalchargeableweight')?.setValidators([
      Validators.required,
      Validators.pattern(/^\d{0,9}(\.\d{0,3})?$/)
    ]);

    // Re-enable disabled controls if needed
    this.piecesForm.get('totalpieces')?.disable();
    this.piecesForm.get('totalactualweight')?.disable();
    this.piecesForm.get('totalvolumetricweight')?.disable();
    this.piecesForm.get('totalchargeableweight')?.disable();

    // Reapply validators for nested form groups
    const shipperLocationDetails = this.awbDetailsForm.get('shipperlocationdetails');
    shipperLocationDetails?.get('ddlCountry')?.setValidators([Validators.required]);
    shipperLocationDetails?.get('ddlState')?.setValidators([Validators.required]);
    shipperLocationDetails?.get('ddlCity')?.setValidators([Validators.required]);
    shipperLocationDetails?.get('txtAddress1')?.setValidators([Validators.required]);
    shipperLocationDetails?.get('txtArea')?.setValidators([Validators.required, Validators.maxLength(30)]);
    shipperLocationDetails?.get('txtMobileNo')?.setValidators([Validators.required, MobileNumberValidation]);
    shipperLocationDetails?.get('txtTelephoneNo')?.setValidators([MobileNumberValidation]);

    const consigneeLocationDetails = this.awbDetailsForm.get('consigneelocationdetails');
    consigneeLocationDetails?.get('ddlCountry')?.setValidators([Validators.required]);
    consigneeLocationDetails?.get('ddlState')?.setValidators([Validators.required]);
    consigneeLocationDetails?.get('ddlCity')?.setValidators([Validators.required]);
    consigneeLocationDetails?.get('txtAddress1')?.setValidators([Validators.required]);
    consigneeLocationDetails?.get('txtArea')?.setValidators([Validators.required, Validators.maxLength(30)]);
    consigneeLocationDetails?.get('txtMobileNo')?.setValidators([Validators.required, MobileNumberValidation]);
    consigneeLocationDetails?.get('txtTelephoneNo')?.setValidators([MobileNumberValidation]);

    // Ensure validators are retained and applied
    this.awbDetailsForm.updateValueAndValidity();
    this.piecesForm.updateValueAndValidity();
  }

  async checkCreditLimit(creditInitials: any) {
    const creditObj = {
      totalamount: parseFloat(creditInitials?.charges?.totalamount),
      customerid: creditInitials?.customerid || null,
      servicecenterid: creditInitials.generatedfromid
    };

    this.ngxLoaderService.start();
    try {
      const res = await lastValueFrom(this.creditControlService.CheckCreditLimit(creditObj));
      if (res?.success && res.data) {
        // console.log('credit-control', res);
        if (res?.data?.err_msg) {
          this.openWarningDialog(res.data.err_msg);
          return false;
        }
        return true;
      }
    } catch (error) {
      console.error('Error checking credit limit:', error);
      return false;
    } finally {
      this.ngxLoaderService.stop();
    }
  }

  async openSuccessDialog(msg: string) {
    await Swal.fire({
      // title: 'Success!'
      html: msg,
      icon: 'success',
      confirmButtonText: 'OK',
      allowEscapeKey: false,
      allowOutsideClick: false
    })
  }

  resetManifestForm() {
    this.manifestFormSubmitted = false;
    this.manifestForm.reset();
    this.manifestForm.get('manifestFor').setValue('Service Center');
    this.manifestForm.get('txtDateTime').setValue(this.currentDateTime?.dateString);
  }

  validateDate(): void {
    const enteredDate = new Date(this.manifestForm.get('txtDateTime')?.value);
    const minAllowedDate = new Date(this.minDateTime);

    if (isNaN(enteredDate.getTime()) || isNaN(minAllowedDate.getTime())) {
      // If either date is invalid, set an error (optional)
      this.manifestForm.get('txtDateTime')?.setErrors({ invalidDate: true });
      return;
    }

    if (enteredDate < minAllowedDate) {
      this.manifestForm.get('txtDateTime')?.setErrors({ minDate: true });
    } else {
      this.manifestForm.get('txtDateTime')?.setErrors(null);
    }
  }

  calculateWeightNew(index?: number) {
    let totalPieces = 0, totalActualWeight = 0, totalVolumetricWeight = 0, totalChargeableWeight = 0;
    for (const container of this.containers.controls) {
      // console.log('container', container);
      let pieceCount = container.get('piecescount').value || 0;
      let piecesactualweight = container.get('piecesactualweight').value || 0;
      let piecesvolumetricweight = container.get('piecesvolumetricweight').value || 0;
      let pieceschargeableweight = container.get('pieceschargeableweight').value || 0;
      let pieceslength = container.get('pieceslength').value || 0;
      let piecesbreadth = container.get('piecesbreadth').value || 0;
      let piecesheight = container.get('piecesheight').value || 0;
      if ((pieceslength * piecesbreadth * piecesheight) > 0) {
        container.get('piecesvolumetricweight').disable();
      }
      container.get('pieceschargeableweight').setValue((Math.max(pieceCount * piecesactualweight, piecesvolumetricweight)).toFixed(3));
      // console.log(pieceCount, piecesactualweight);
      totalPieces += pieceCount;
      totalActualWeight += parseFloat((pieceCount * piecesactualweight).toString());
      totalVolumetricWeight += parseFloat(piecesvolumetricweight);
    }
    // const isNotWeightValid = this.validateActualWeight(totalActualWeight);
    // if (isNotWeightValid) {
    //   const containerControl = this.containers?.controls[index];
    //   const volWeight = containerControl?.get('piecesvolumetricweight')?.value;
    //   containerControl?.get('piecesactualweight')?.reset();
    //   containerControl?.get('pieceschargeableweight')?.setValue(volWeight ?? '0');
    //   return this.warningDialog(isNotWeightValid);
    // }
    this.piecesForm.get('totalpieces').setValue(totalPieces);
    this.piecesForm.get('totalactualweight').setValue(totalActualWeight.toFixed(3));
    this.piecesForm.get('totalvolumetricweight').setValue(totalVolumetricWeight.toFixed(3));

    totalChargeableWeight = this.piecesForm.get('totalchargeableweight')?.value;
    this.piecesForm.get('totalchargeableweight').setValue(Math.max(+totalActualWeight.toFixed(3), +totalVolumetricWeight.toFixed(3)));

    // call getAWBCharges if totalchargeableweight's first vale differs from new one
    // totalChargeableWeight != this.piecesForm.get('totalchargeableweight')?.value && this.getAWBCharges(this.category.CUSTOMER);

  }

  validateActualWeight(totalactualweight: any) {
    if (totalactualweight == null || !this.vendorWeightInfo) {
      return null;
    }
    const { min, max } = this.vendorWeightInfo;

    if ((max && totalactualweight > max) || (min && totalactualweight < min)) {
      return `Total actual weight must be between ${min} and ${max}`;
    }

    return null;
  };
  vendorWeightInfo: any = {};

}